/**
 * Custom JS
 */
globalThis.autoApplyCouponCode = function (discount_code = "", expires = 3) {
  const anchor = $("#markdown-anchor");
  if (inIframe() || !anchor.length) {
    return !0;
  }
  const current_discount = Cookies.get("markdown_discount_code") || "";
  const code = discount_code || current_discount;
  if (!code) return;
  if (current_discount !== code) {
    const frame = `<iframe src="https://${globalThis.location.hostname}/discount/${code}" style="width:0;height:0;border:0;border:none;position:absolute;"></iframe>`;
    $("#markdown-anchor").html(frame);
    setCookieWithExpiry("markdown_discount_code", code, 3);
  }
};

globalThis.MarkdownPricePro = {
  // register() — saves a markdown config to localStorage without triggering
  // a DOM render. Use this when registering multiple markdowns in a batch so
  // that a single coordinated render pass can be issued afterwards. All
  // callers that need an immediate single-markdown render should use init().
  register({
    discount_code,
    multiplier = 0,
    collections = [],
    subtract = !1,
    expires = 3,
    autoApplyCoupon = !0,
    overwriteOthers = false,
    id,
    variants = [],
    collectionSpecific = false,
    includeInSubtotal = true,
    hideStrikethrough = false,
    packSizes = [],
  }) {
    if (!id)
      return console.error(
        "Markdown ID is required to register a markdown!"
      );
    if (!collections.length)
      return console.error(
        "At least one collection is required to register a markdown!"
      );
    if (multiplier <= 0)
      console.warn(`0% discount will be applied on checkout`);
    let markdownObject = localStorageUtils.get("markdown_object") || [];
    let newMarkdown = {};
    if (markdownObject.length) {
      const existing = markdownObject.find(
        (obj) => obj.markdown_id === `${id}`
      );
      if (existing) {
        markdownObject = markdownObject.filter(
          (obj) => obj.markdown_id !== `${id}`
        );
        newMarkdown = existing;
      }
    }
    // When packSizes is given, scope the selector (and the run() multiplier
    // lookup, see collectionMultiplierMap below) to those pack sizes only —
    // this lets two markdowns target the SAME collection at DIFFERENT rates
    // per pack size (e.g. Last Chance: 25% for 1/3-Pack, 30% for 4/5-Pack)
    // without the "lowest multiplier wins per collection" stacking logic
    // collapsing them into a single rate.
    const selector = packSizes.length
      ? collections
          .flatMap((col) =>
            packSizes.map(
              (size) =>
                `[data-product-coll*="${col}"][data-pack-size="${size}"] span.Price:visible`
            )
          )
          .join(", ")
      : collections
          .map((col) => `[data-product-coll*="${col}"] span.Price:visible`)
          .join(", ");
    console.log(
      `Markdown with id ${id} registered! ${new Date().toDateString()}`
    );
    newMarkdown.markdown_multiplier = `${multiplier}`;
    newMarkdown.markdown_id = `${id}`;
    newMarkdown.markdown_mode = subtract ? "subtract" : "multiply";
    newMarkdown.markdown_collections = collections.join(",");
    newMarkdown.markdown_pack_sizes = packSizes.join(",");
    newMarkdown.markdown_selector = selector;
    newMarkdown.markdown_overwrite_others = overwriteOthers;
    if (discount_code) {
      newMarkdown.markdown_discount_code = discount_code;
    }
    newMarkdown.markdown_auto_apply_coupon = autoApplyCoupon;
    newMarkdown.markdown_variants = variants;
    newMarkdown.markdown_collection_specific = collectionSpecific;
    newMarkdown.markdown_include_in_subtotal = includeInSubtotal;
    newMarkdown.markdown_hide_strikethrough = hideStrikethrough;
    newMarkdown.markdown_initialized = "initialized";
    markdownObject.push(newMarkdown);
    localStorageUtils.set("markdown_object", markdownObject, expires);
    // No run() — caller is responsible for rendering after batch registration.
  },

  init({
    discount_code,
    multiplier = 0,
    collections = [],
    subtract = !1,
    expires = 3,
    autoApplyCoupon = !0,
    overwriteOthers = false,
    id,
    variants = [],
    collectionSpecific = false,
    includeInSubtotal = true,
    hideStrikethrough = false,
  }) {
    this.register({
      discount_code,
      multiplier,
      collections,
      subtract,
      expires,
      autoApplyCoupon,
      overwriteOthers,
      id,
      variants,
      collectionSpecific,
      includeInSubtotal,
      hideStrikethrough,
    });
    this.run();
  },

  upsert({ markdowns = [], apply = false }) {
    const markdownObject = localStorageUtils.get("markdown_object") || [];

    // Create a Map for O(1) lookups and updates - more efficient than array.find()
    const markdownMap = new Map(
      markdownObject.map((obj) => [obj.markdown_id, obj])
    );

    // Track IDs to remove (disabled markdowns)
    const idsToRemove = new Set();

    // Process each markdown
    for (const markdown of markdowns) {
      const {
        discount_code,
        multiplier = 0,
        collections = [],
        subtract = !1,
        expires = 3,
        autoApplyCoupon = !0,
        overwriteOthers = false,
        id,
        variants = [],
        collectionSpecific = false,
        includeInSubtotal = true,
        hideStrikethrough = false,
        disabled = false,
      } = markdown;

      // Convert id once to avoid repeated string conversion
      const markdownId = `${id}`;

      // Handle disabled markdowns: remove if exists in storage, don't save if not
      if (disabled) {
        if (markdownMap.has(markdownId)) {
          idsToRemove.add(markdownId);
        }
        continue;
      }

      // Early validation - skip invalid items
      if (!id) {
        console.error("Markdown ID is required to upsert markdown!");
        continue;
      }
      if (!collections.length) {
        console.error(
          "At least one collection is required to upsert markdown!"
        );
        continue;
      }
      if (multiplier <= 0) {
        console.warn(`0% discount will be applied on checkout`);
      }

      // Get existing markdown or create new one
      const existingMarkdown = markdownMap.get(markdownId) || {};

      // Build selector once
      const selector = collections
        .map((col) => `[data-product-coll*="${col}"] span.Price:visible`)
        .join(", ");

      // Create/update markdown object efficiently
      const newMarkdown = {
        ...existingMarkdown,
        markdown_multiplier: `${multiplier}`,
        markdown_id: markdownId,
        markdown_mode: subtract ? "subtract" : "multiply",
        markdown_collections: collections.join(","),
        markdown_selector: selector,
        markdown_overwrite_others: overwriteOthers,
        markdown_auto_apply_coupon: autoApplyCoupon,
        markdown_variants: variants,
        markdown_collection_specific: collectionSpecific,
        markdown_include_in_subtotal: includeInSubtotal,
        markdown_hide_strikethrough: hideStrikethrough,
        markdown_initialized: "initialized",
      };

      // Add discount code only if provided
      if (discount_code) {
        newMarkdown.markdown_discount_code = discount_code;
      }
      // Update the map
      markdownMap.set(markdownId, newMarkdown);
    }

    // Remove disabled markdowns from the map
    for (const idToRemove of idsToRemove) {
      markdownMap.delete(idToRemove);
    }

    // Convert map back to array and save to localStorage
    const updatedMarkdownArray = Array.from(markdownMap.values());
    localStorageUtils.set("markdown_object", updatedMarkdownArray, 3);
    if (apply) {
      this.run();
    }
  },

  clear(id) {
    if (!id) {
      return console.log("You need to supply the ID of the markdown to clear");
    }
    if (id === "clear-all") {
      localStorageUtils.remove("markdown_object");
    } else {
      const markdownObject = localStorageUtils.get("markdown_object") || [];
      const existing = markdownObject.find(
        (obj) => obj.markdown_id === `${id}`
      );
      if (!existing) {
        return console.log("No such markdown with id:", id, "to clear!");
      }

      const discount_code = existing?.markdown_discount_code;
      const applied_discount_coupon = Cookies.get("markdown_discount_code");
      if (discount_code && applied_discount_coupon === discount_code) {
        Cookies.remove("markdown_discount_code");
      }

      const rest = markdownObject.filter((obj) => obj.markdown_id !== `${id}`);
      if (rest.length) {
        localStorageUtils.set("markdown_object", rest, 3);
      } else {
        localStorageUtils.remove("markdown_object");
      }
    }
    $("#markdown-anchor").html("");
  },

  // Single source of truth for "what multiply-mode discount actually applies
  // to a product with these collections at this pack size" — reads straight
  // from the registered markdown_object instead of a caller hardcoding rates
  // (e.g. Last Chance's 25%/30% tiers) that only really live here. Mirrors
  // the pack-size-scoped "lowest multiplier wins" lookup used by run()'s
  // collectionMultiplierMap: a markdown registered with packSizes only
  // qualifies when packSize is in that list; one registered without
  // packSizes matches any pack size. Returns 1 (no discount) when nothing
  // matches.
  getMultiplierForPackSize(collections = [], packSize) {
    const markdownObject = localStorageUtils.get("markdown_object") || [];
    let best = 1;
    markdownObject.forEach((object) => {
      if (object.markdown_mode === "subtract") return;
      if (object.markdown_initialized !== "initialized") return;
      const objectCollections = object.markdown_collections
        ? object.markdown_collections.split(",")
        : [];
      if (!objectCollections.some((c) => collections.includes(c))) return;
      const packSizes = object.markdown_pack_sizes
        ? object.markdown_pack_sizes.split(",")
        : [];
      if (packSizes.length && !packSizes.includes(`${packSize}`)) return;
      const multiplier = Number(object.markdown_multiplier);
      if (multiplier < best) best = multiplier;
    });
    return best;
  },

  run({ is_product_page = !1, overwriteOthers = false, skipSubtract = false, skipMultiply = false } = {}) {
    const markdownObject = (localStorageUtils.get("markdown_object") || []).sort(
      (a, b) => (a.markdown_mode === "subtract" ? -1 : 1) - (b.markdown_mode === "subtract" ? -1 : 1)
    );
    if (!markdownObject.length) return;

    // Cache constants outside all loops
    const { template } = globalThis.themeVariables;
    const pathname = globalThis.location.pathname;
    const curr = user_currency === "GBP" ? "£" : "$";
    const currencyRate = currency_conversion[user_currency];
    const isProductTemplate = template.includes("product");

    // Cache formatter - same config for all elements
    const formatter = new Intl.NumberFormat("en-US", {
      style: "decimal",
      currency: user_currency,
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
      useGrouping: !1,
    });

    // Pre-filter markdowns: remove uninitialized and non-matching collection-specific ones
    const validMarkdowns = markdownObject.filter((object) => {
      if (object.markdown_initialized !== "initialized") {
        console.log(
          `Markdown Price with ${object.markdown_id} not initialized!`
        );
        return false;
      }

      // skipSubtract: chain pass — only multiply markdowns run in overwrite mode.
      // This prevents the DOM-update conflict where subtract and lastchance both
      // collect the same [data-target="price-element"] and only the first wins.
      if (skipSubtract && object.markdown_mode === "subtract") return false;
      // skipMultiply: subtract-only overwrite pass — required because Convert
      // Experiences adds price-ab-regular asynchronously after page load. By then
      // all multiply markdowns (lastchance, AT20) have already run and replaced
      // span.Price with [data-target="price-element"]. This step re-processes those
      // elements with subtract only, writing data-original-price so the chain pass
      // (skipSubtract) can detect and correctly stack the multiply on top.
      if (skipMultiply && object.markdown_mode !== "subtract") return false;

      const collectionSpecific = object.markdown_collection_specific || false;
      if (collectionSpecific) {
        if (!template.includes("collection")) return false;
        const collections = object.markdown_collections.split(",");
        return collections.some((col) => pathname.includes(col));
      }
      return true;
    });

    if (!validMarkdowns.length) return;
    
    // Build collection->multiplier lookup map for O(1) discount calculations.
    // Markdowns registered with packSizes are keyed as "col::size" instead of
    // just "col", so two markdowns can target the same collection at
    // different rates per pack size (see register()'s packSizes comment).
    // Plain collection-only markdowns are unaffected — same "lowest wins"
    // behavior as before.
    const collectionMultiplierMap = new Map();
    validMarkdowns.forEach((object) => {
      const multiplier = Number(object.markdown_multiplier);
      const packSizes = object.markdown_pack_sizes
        ? object.markdown_pack_sizes.split(",")
        : [];
      object.markdown_collections.split(",").forEach((col) => {
        const keys = packSizes.length
          ? packSizes.map((size) => `${col}::${size}`)
          : [col];
        keys.forEach((key) => {
          const existing = collectionMultiplierMap.get(key);
          if (existing === undefined || multiplier < existing) {
            collectionMultiplierMap.set(key, multiplier);
          }
        });
      });
    });

    // Cache sessionStorage value once (used in variant logic)
    const cachedSelectedSize = sessionStorage.getItem("product-selected-size");

    // Exclusion selector - computed once
    const exclusionSelector =
      ".Price--compareAt, .Price--FullPrice, .Price--Discounted, .markdown-price, .old_money, .old-price.Price";
    const overwriteExclusionSelector =
      ".Price--compareAt, .Price--FullPrice, .Price--Discounted, .old_money, .old-price.Price";

    // Collect all DOM updates to batch at the end
    const domUpdates = [];

    validMarkdowns.forEach((object) => {      
      let selectors = object.markdown_selector;
      const mode = object.markdown_mode;
      const hideStrikethrough = object.markdown_hide_strikethrough || false;
      const markdown_overwrite_others =
        object.markdown_overwrite_others || overwriteOthers;
      const markdown_variants = object.markdown_variants || [];

      // Build variant lookup map for O(1) lookups if variants exist
      let variantMultiplierMap = null;
      if (markdown_variants.length) {
        variantMultiplierMap = new Map();
        markdown_variants.forEach((variant) => {
          if (variant.multiplier) {
            variant.titles.forEach((title) => {
              variantMultiplierMap.set(
                title.toLowerCase(),
                Number(variant.multiplier)
              );
            });
          }
        });
      }

      if (markdown_overwrite_others) {
        selectors = selectors.replace(
          /span\.Price:visible/g,
          'span[data-target="price-element"]'
        );
      }

      // Single DOM query with appropriate exclusions
      let priceElements = $(selectors).not(
        markdown_overwrite_others
          ? overwriteExclusionSelector
          : exclusionSelector
      );

      if (is_product_page) {
        priceElements = priceElements.filter(function () {
          return $(this).parents(".product-price").length >= 1;
        });
      }

      // Get raw DOM elements for faster iteration
      const elements = priceElements.get();
      const elementsLength = elements.length;

      for (let i = 0; i < elementsLength; i++) {
        const el = elements[i];
        const $el = $(el);

        // Skip already discounted - check data attribute directly
        if (el.dataset.isDiscounted) continue;

        const $parent = $el.parent();
        const parentEl = $parent[0];
        const $grandparent = $parent.parent();

        // In overwrite mode (pass-2), skip elements that are the FINAL multiply
        // output: they have .money.markdown-price inside but no data-original-price.
        // data-original-price is only set by subtract markdowns; its absence means
        // the full chain (subtract → multiply) has already completed on this element.
        // Re-running multiply on it reads the wrong base (raw data-discounted-price)
        // and produces a compounded or incorrect price.
        if (
          markdown_overwrite_others &&
          el.querySelector(".money.markdown-price") &&
          !el.dataset.originalPrice
        ) {
          continue;
        }

        // Check if this is a cart item (unit-price column OR line-total column)
        const isCartItem =
          $grandparent[0]?.classList.contains("CartItem__PriceList") ||
          $grandparent[0]?.classList.contains("CartItem__LinePriceList");

        // Calculate multiplier.
        // Subtract mode: bypass the collectionMultiplierMap (which uses "lowest value wins"
        // logic designed for multiply fractions — this breaks for subtract amounts like 1 or 3
        // because 1 < 1 is false and the skip guard `multiplier === 1` kills $1 rules).
        // Instead, check if the element's collections intersect this markdown's collections directly.
        // Multiply mode: keep the existing O(1) map lookup (lowest fraction = biggest discount).
        const productColl = $parent.data("product-coll");
        let multiplier;
        if (mode === "subtract") {
          const objectCollections = new Set(object.markdown_collections.split(","));
          const elementCollections = productColl ? productColl.split(",") : [];
          if (!elementCollections.some((c) => objectCollections.has(c))) continue;
          multiplier = Number(object.markdown_multiplier);
        } else {
          multiplier = 1;
          if (productColl) {
            const collections = productColl.split(",");
            const elementPackSize = $parent.data("pack-size");
            for (const element of collections) {
              // Pack-size-scoped key first (e.g. a Last Chance rate that only
              // applies to this element's own pack size), falling back to the
              // plain collection key for markdowns registered without
              // packSizes — same behavior as before for those.
              const packSizeKey =
                elementPackSize !== undefined
                  ? collectionMultiplierMap.get(`${element}::${elementPackSize}`)
                  : undefined;
              const colMultiplier =
                packSizeKey !== undefined
                  ? packSizeKey
                  : collectionMultiplierMap.get(element);
              if (colMultiplier !== undefined && colMultiplier < multiplier) {
                multiplier = colMultiplier;
              }
            }
          }
          if (multiplier === 1) continue; // no matching collection for multiply mode
        }

        // Handle variant-specific multipliers
        if (variantMultiplierMap) {
          // For cart items, get variant title from parent's data attribute
          let selectedSize = isCartItem
            ? $parent.data("variant-title")
            : el.dataset?.variantTitle;

          if (
            isProductTemplate &&
            parentEl.classList.contains("pro-main-price")
          ) {
            selectedSize =
              cachedSelectedSize ||
              $('.SizeSwatch__Radio.MainProduct[type="radio"]:checked').val();
          }

          if (selectedSize) {
            const variantMultiplier = variantMultiplierMap.get(
              selectedSize.toLowerCase()
            );
            if (variantMultiplier !== undefined) {
              multiplier = variantMultiplier;
            }
          }
        }

        // For hideStrikethrough rules, read stored original price if available.
        // color-dot:changed fires run({ overwriteOthers: true }) which targets
        // span[data-target="price-element"] — i.e. elements already processed by
        // a previous run(). Without this guard the discount would compound on every
        // dot change ($49 → $48 → $47 → …). We store the original price in
        // data-original-price on first write and always subtract from that value.
        const storedOriginalPrice =
          hideStrikethrough ? parseFloat($el.data("original-price") || 0) : 0;

        // When a multiply markdown chains on top of a hideStrikethrough subtract
        // markdown (the second overwriteOthers pass in initPriceABTest), old_money
        // holds the adjusted compare-at price, not the sale price. Read from
        // .money.markdown-price instead so the multiplier applies to the correct base.
        const isChainedOnSubtract =
          markdown_overwrite_others &&
          !hideStrikethrough &&
          parseFloat($el.data("original-price") || 0) > 0;
        const $oldMoney = $el.find(".old_money");
        const $markdownPriceEl = isChainedOnSubtract
          ? $el.find(".money.markdown-price")
          : null;
        const price =
          storedOriginalPrice > 0
            ? `${storedOriginalPrice}` // will be overridden by storedOriginalPrice below
            : $markdownPriceEl?.length
              ? $markdownPriceEl.html()
              : $oldMoney.length
                ? $oldMoney.html()
                : $el.html();

        const prices = price.match(/[-+]?[0-9]*\.?[0-9]+/g) || [];

        let price_value = storedOriginalPrice > 0 ? storedOriginalPrice : prices[0];
        const compare_price = $el
          .parents("[data-product-coll]")
          .attr("data-discounted-price");
        // Don't let data-discounted-price override the price we read from
        // .money.markdown-price when chaining a multiply on top of a subtract.
        // data-discounted-price holds the original Shopify sale price, which would
        // undo the subtract discount and apply the multiplier to the wrong base.
        if (compare_price && !isChainedOnSubtract) {
          price_value = Number(compare_price) / 100;
        }

        // For cart items, use data-price attribute if available (more accurate)
        if (isCartItem) {
          const dataPrice = $el.data("price");
          if (dataPrice) {
            price_value = Number(dataPrice) / 100;
          }
        }

        // For subtract markdowns the per-pair amount is multiplied by pack size
        // (e.g. $2/pair × 3-Pack = $6 off the pack price).
        // Round to cents — do NOT Math.floor, or fractional subtracts like 2
        // collapse to 1.00 and prices end up 1¢ high (32.99 − 1 = 31.99 vs 31.98).
        const packSize =
          mode === "subtract"
            ? Math.max(
                1,
                parseInt(
                  $el.parents("[data-product-coll]").attr("data-pack-size") ||
                    "1",
                  10
                ) || 1
              )
            : 1;
        const subtractAmount =
          mode === "subtract"
            ? Math.round(multiplier * packSize * currencyRate * 100) / 100
            : 0;

        // Pre-compute compare-at adjustments before calculatedNewPrice so the
        // new sale formula can reference them.
        // For subtract + hideStrikethrough with a compare-at price:
        //   adjustedCompare = compareAt − (subtract × packSize)
        //   sale             = adjustedCompare × 0.9  (fixed ratio, always 0.9)
        // For no compare-at price or non-hideStrikethrough, standard formula is used.
        const comparePrice = $el.data("compare-price");
        let adjustedComparePrice = null;
        let comparePriceNum = 0;
        if (hideStrikethrough && comparePrice) {
          comparePriceNum =
            typeof comparePrice === "string"
              ? parseFloat(comparePrice.match(/[-+]?[0-9]*\.?[0-9]+/g)?.[0] || 0)
              : comparePrice / 100;
          if (comparePriceNum > 0) {
            const adjustedCompare = comparePriceNum - subtractAmount;
            adjustedComparePrice = formatter.format(adjustedCompare);
          }
        } else if (hideStrikethrough && !comparePrice) {
          // The element may have been pre-processed by another markdown (e.g. lastchance)
          // before the A/B subtract pass runs. The previous markdown replaces the original
          // DOM node, losing its data-compare-price attribute. However, if that markdown
          // used the Shopify compare-at as its strikethrough, old_money will hold a value
          // strictly greater than the current sale price (price_value).
          // Recover it as comparePriceNum so the A/B pass can compute the correct
          // adjusted compare-at ($149.95 − $15 = $134.95) and pass it on to Pass B.
          const omNums = $oldMoney.length
            ? $oldMoney.text().match(/[-+]?[0-9]*\.?[0-9]+/g)
            : null;
          if (omNums) {
            const omVal = parseFloat(omNums[0]);
            if (omVal > price_value + 0.01) {
              comparePriceNum = omVal;
              const adjustedCompare = omVal - subtractAmount;
              adjustedComparePrice = formatter.format(adjustedCompare);
            }
          }
        }

        const calculatedNewPrice =
          mode === "subtract" && hideStrikethrough && comparePriceNum > 0
            ? (comparePriceNum - subtractAmount) * 0.9
            : mode === "subtract"
              ? price_value - subtractAmount
              : multiplier * price_value;

        const new_price = formatter.format(calculatedNewPrice);

        // For cart items, verify if discount is already properly applied
        if (isCartItem) {
          const currentDisplayedPrice = parseFloat(prices[0] || 0);
          const expectedDiscountedPrice = parseFloat(
            calculatedNewPrice.toFixed(2)
          );

          // Already exactly at the markdown price — skip
          if (
            Math.abs(currentDisplayedPrice - expectedDiscountedPrice) < 0.01
          ) {
            continue;
          }

          // Current price is already BETTER (lower) than what this markdown
          // would produce — e.g. the Cart Transform Function stacked subtract +
          // multiply and Liquid rendered the correct final price. Don't overwrite.
          if (currentDisplayedPrice < expectedDiscountedPrice - 0.01) {
            continue;
          }

          // Check if element already has markdown-price class (already discounted)
          if (el.classList.contains("markdown-price")) {
            if (currentDisplayedPrice <= expectedDiscountedPrice) {
              continue; // Discount is equal or better, skip
            }
          }
        }

        let old_price = formatter.format(price_value);
        // comparePrice, comparePriceNum, and adjustedComparePrice are computed
        // above (before calculatedNewPrice) so the sale formula can use them.
        if (isChainedOnSubtract && $oldMoney.length) {
          // Pass A (subtract) already placed the correct adjusted compare-at in
          // old_money (e.g. $159.95 = compareAt − factor). Preserve it as the
          // strikethrough so the stacked display reads:
          //   $159.95 strikethrough → $115.16 (AT20/lastchance applied on top).
          const oldMoneyNums = $oldMoney.text().match(/[-+]?[0-9]*\.?[0-9]+/g);
          if (oldMoneyNums) old_price = oldMoneyNums[0];
        } else if (comparePrice && !isChainedOnSubtract) {
          // Non-chained case: use the Shopify compare-at as strikethrough.
          old_price =
            typeof comparePrice === "string"
              ? comparePrice.match(/[-+]?[0-9]*\.?[0-9]+/g)
              : comparePrice / 100;
        }

        // Check parent classes once using native classList
        const isOldMoney = el.classList.contains("old_money");
        const isProMainPrice = parentEl.classList.contains("pro-main-price");
        const isProductPriceBlock = parentEl.classList.contains(
          "product-price-block"
        );
        const isProductItemPriceList = parentEl.classList.contains(
          "ProductItem__PriceList"
        );
        const isWasParent = parentEl.classList.contains("was");

        // hideStrikethrough behaviour:
        //   • compare-at price exists → show adjusted compare (strikethrough) + adjusted sale price
        //   • no compare-at price     → show only the single final price, no pill
        // data-original-price preserves the pre-discount value so that repeated
        // run() calls (e.g. from color-dot:changed) always subtract from the
        // true original rather than the already-discounted displayed price.
        // data-compare-price is forwarded onto the wrapper (prefixed with curr to
        // keep it as a string so jQuery doesn't auto-convert it to a number) so that
        // overwrite-pass runs triggered by color-dot:changed can still compute the
        // adjusted compare price correctly.
        const originalPriceAttr = hideStrikethrough
          ? ` data-original-price="${price_value}"${adjustedComparePrice ? ` data-compare-price="${curr}${comparePriceNum}"` : ""}`
          : "";
        const content = price_value
          ? hideStrikethrough
            ? adjustedComparePrice
              ? `<span data-target="price-element" data-value="markdown_price"${originalPriceAttr}><span class="money markdown-price">${curr}${new_price}</span><span class="old_money">${curr}${adjustedComparePrice}</span></span>`
              : `<span data-target="price-element" data-value="markdown_price"${originalPriceAttr}><span class="money markdown-price">${curr}${new_price}</span></span>`
            : `<span data-target="price-element" data-value="markdown_price"><span class="money markdown-price">${curr}${new_price}</span><span class="old_money">${
                isCartItem ? "" : "List: "
              }${curr}${old_price}</span></span>`
          : `<span data-target="price-element" data-value="markdown_price"><span class="money">${price}</span></span>`;

        const discountPill =
          mode === "subtract"
            ? `<div class="discount-label">${curr}${multiplier} off</div>`
            : `<div class="discount-label">${100 - multiplier * 100}% off</div>`;

        // Queue DOM updates instead of executing immediately        
        domUpdates.push(() => {
          $parent.find(".was").addClass("hidden");

          if (isOldMoney) {
            $parent.replaceWith(content);
          } else {
            $el.replaceWith(content);
          }

          $parent.find(".Price--compareAt, .old-price").hide();

          if (isWasParent) {
            $parent.hide();
          }

          // Skip pill entirely when hideStrikethrough is active or for cart items
          if (isCartItem || hideStrikethrough) {
            return;
          }

          if (isProMainPrice) {
            const $productMeta = $parent.parents(".ProductMeta");
            const $productReviewContainer = $productMeta.find(
              ".ProductPriceReview"
            );
            if ($productReviewContainer.length) {
              $productMeta.find(".discount-label").remove();
              $productReviewContainer.after(discountPill);
            }
          } else if (isProductPriceBlock) {
            $parent.prev(".discount-label").remove();
            $parent.before(discountPill);
          } else if ($parent.parents(".upsell-item-wrapper").length) {
            $parent.find(".discount-label").remove();
            $parent.append(discountPill);
          } else if (isProductItemPriceList) {
            $parent.prev(".discount-label").remove();
            $parent.before(discountPill);
          }
        });
      }
    });

    // Process cart items — corrects prices the main forEach loop may have
    // missed. For products in both a subtract and a multiply collection,
    // stacks subtract first then applies the multiplier (mirrors the
    // three-pass chain used for PLP/PDP on initial load).
    document
      .querySelectorAll(".CartItem__PriceList [data-product-coll], .CartItem__LinePriceList [data-product-coll]")
      .forEach((cartItemWrapper) => {
        const productColl = cartItemWrapper.dataset.productColl;
        if (!productColl) return;

        const collections = productColl.split(",");
        const cartItemPackSize = cartItemWrapper.dataset.packSize;

        // Find the best subtract markdown for this product
        const subtractMarkdown = validMarkdowns.find((m) => {
          if (m.markdown_mode !== "subtract") return false;
          const mCols = m.markdown_collections.split(",");
          return mCols.some((c) => collections.includes(c));
        });

        // Find the best (lowest multiplier) multiply markdown for this product.
        // Markdowns registered with packSizes (e.g. Last Chance's 25%/30% tiers
        // sharing one collection) only qualify when this cart item's own pack
        // size is in that list — otherwise a 1-Pack item would match a 5-Pack
        // -only markdown just because "lowest multiplier wins" ignored pack
        // size entirely.
        const multiplyMarkdown = (() => {
          let best = null;
          for (const m of validMarkdowns) {
            if (m.markdown_mode === "subtract") continue;
            const mCols = m.markdown_collections.split(",");
            if (!mCols.some((c) => collections.includes(c))) continue;
            const mPackSizes = m.markdown_pack_sizes
              ? m.markdown_pack_sizes.split(",")
              : [];
            if (
              mPackSizes.length &&
              (!cartItemPackSize || !mPackSizes.includes(cartItemPackSize))
            )
              continue;
            const mult = Number(m.markdown_multiplier);
            if (best === null || mult < Number(best.markdown_multiplier)) {
              best = m;
            }
          }
          return best;
        })();

        if (!subtractMarkdown && !multiplyMarkdown) return;

        const priceEl = cartItemWrapper.querySelector(".CartItem__Price.Price");
        if (!priceEl) return;

        // Skip if already correctly processed
        if (
          priceEl.dataset.isDiscounted ||
          priceEl.closest('[data-value="markdown_price"]')
        )
          return;

        const $priceEl = $(priceEl);

        // Get original price from data attribute or text
        let originalPrice = $priceEl.data("price");
        if (originalPrice) {
          originalPrice = Number(originalPrice) / 100;
        } else {
          const priceText = priceEl.textContent;
          const priceMatch = priceText.match(/[-+]?[0-9]*\.?[0-9]+/g);
          originalPrice = priceMatch ? parseFloat(priceMatch[0]) : 0;
        }
        if (!originalPrice) return;

        // Per-pair subtract amount × pack count (e.g. $3 × 3-Pack = $9 off)
        const cartPackSize =
          Math.max(1, parseInt(cartItemWrapper.dataset.packSize || "1", 10) || 1);

        // Resolve hideStrikethrough early so the compare-at formula can use it.
        const hideStrikethrough =
          subtractMarkdown?.markdown_hide_strikethrough || false;

        // For hideStrikethrough subtract items that carry a compare-at price the
        // sale price formula is: (compareAt − factor×packSize) × 0.9 — matching
        // the main-loop logic and the Cart Transform Function.
        const rawCartCompare = hideStrikethrough
          ? ($priceEl.data("compare-price") || null)
          : null;
        let cartComparePriceNum = 0;
        if (rawCartCompare) {
          cartComparePriceNum =
            typeof rawCartCompare === "string"
              ? parseFloat(rawCartCompare.match(/[-+]?[0-9]*\.?[0-9]+/g)?.[0] || 0)
              : rawCartCompare / 100;
        }

        // Step 1: apply subtract (if applicable)
        const subtractAmount = subtractMarkdown
          ? Number(subtractMarkdown.markdown_multiplier)
          : 0;
        const subtractOff =
          Math.round(subtractAmount * cartPackSize * currencyRate * 100) / 100;
        const priceAfterSubtract = subtractMarkdown
          ? cartComparePriceNum > 0
            ? (cartComparePriceNum - subtractOff) * 0.9
            : originalPrice - subtractOff
          : originalPrice;

        // Pre-compute adjustedCompare (compareAt − factor) for use in both isStacked
        // and hideStrikethrough display branches and the strikethrough correction check.
        // For products without a compare-at, adjustedCompareStr stays null.
        const adjustedCompare = cartComparePriceNum > 0
          ? cartComparePriceNum - subtractOff
          : 0;
        let adjustedCompareStr = adjustedCompare > 0
          ? formatter.format(adjustedCompare)
          : null;

        // Step 2: apply multiply (if applicable), accounting for variant overrides
        let effectiveMultiplier = multiplyMarkdown
          ? Number(multiplyMarkdown.markdown_multiplier)
          : null;
        if (multiplyMarkdown && effectiveMultiplier !== null) {
          const variantTitle = cartItemWrapper.dataset.variantTitle;
          validMarkdowns.forEach((object) => {
            const markdown_variants = object.markdown_variants || [];
            if (markdown_variants.length && variantTitle) {
              const matchingVariant = markdown_variants.find((v) =>
                v.titles.some(
                  (t) => t.toLowerCase() === variantTitle.toLowerCase()
                )
              );
              if (matchingVariant && matchingVariant.multiplier) {
                const variantMult = Number(matchingVariant.multiplier);
                if (variantMult < effectiveMultiplier) {
                  effectiveMultiplier = variantMult;
                }
              }
            }
          });
        }

        const finalPrice =
          effectiveMultiplier !== null
            ? priceAfterSubtract * effectiveMultiplier
            : priceAfterSubtract;

        // Get currently displayed price
        const displayedText = priceEl.textContent;
        const displayedMatch = displayedText.match(/[-+]?[0-9]*\.?[0-9]+/g);
        const displayedPrice = displayedMatch
          ? parseFloat(displayedMatch[0])
          : 0;

        const isStacked = !!subtractMarkdown && !!multiplyMarkdown;
        // hideStrikethrough is resolved above (before priceAfterSubtract).

        // For stacked items, check whether the displayed strikethrough is correct.
        // For compare-at products the expected strikethrough is adjustedCompare
        // (compareAt − factor, e.g. $159.95). For non-compare-at products it is
        // priceAfterSubtract (sale − factor). Liquid renders item.original_line_price
        // as the compareAt which equals the Cart Transform output ($143.95) — wrong.
        let strikethroughNeedsCorrection = false;
        if (isStacked) {
          const compareAtEl = cartItemWrapper.querySelector(
            ".Price--compareAt, .old_money"
          );
          if (compareAtEl) {
            const compareAtMatch = compareAtEl.textContent.match(
              /[-+]?[0-9]*\.?[0-9]+/g
            );
            const currentStrikethrough = compareAtMatch
              ? parseFloat(compareAtMatch[0])
              : null;
            if (currentStrikethrough !== null) {
              const expectedStrikethrough = adjustedCompare > 0
                ? adjustedCompare
                : priceAfterSubtract;
              if (Math.abs(currentStrikethrough - expectedStrikethrough) > 0.01) {
                strikethroughNeedsCorrection = true;
              }
            }
          }
        }

        // Only update if the displayed price is wrong or the strikethrough needs correcting
        if (displayedPrice <= finalPrice + 0.01 && !strikethroughNeedsCorrection)
          return;

        const finalPriceStr = formatter.format(finalPrice);

        let content;
        if (isStacked) {
          // Both discounts apply.
          // For compare-at products: strikethrough = adjustedCompare (compareAt − factor)
          // so the cart reads e.g. "$159.95 → $115.16" (AT20 applied on A/B price).
          // For non-compare-at products: strikethrough = priceAfterSubtract (sale − factor).
          const strikeStr = adjustedCompareStr || formatter.format(priceAfterSubtract);
          content = `<span data-target="price-element" data-value="markdown_price"><span class="money markdown-price">${curr}${finalPriceStr}</span><span class="old_money">${curr}${strikeStr}</span></span>`;
        } else if (hideStrikethrough) {
          // Subtract only with hideStrikethrough.
          // adjustedCompareStr is pre-computed above (null when no compare-at price).
          content = adjustedCompareStr
            ? `<span data-target="price-element" data-value="markdown_price"><span class="money markdown-price">${curr}${finalPriceStr}</span><span class="old_money">${curr}${adjustedCompareStr}</span></span>`
            : `<span data-target="price-element" data-value="markdown_price"><span class="money markdown-price">${curr}${finalPriceStr}</span></span>`;
        } else {
          // Multiply only — original price as strikethrough
          const originalStr = formatter.format(originalPrice);
          content = `<span data-target="price-element" data-value="markdown_price"><span class="money markdown-price">${curr}${finalPriceStr}</span><span class="old_money">${curr}${originalStr}</span></span>`;
        }

        domUpdates.push(() => {
          $(cartItemWrapper).html(content);
        });
      });

    // Execute all DOM updates in a single batch using requestAnimationFrame
    if (domUpdates.length) {
      requestAnimationFrame(() => {
        for (let i = 0; i < domUpdates.length; i++) {
          domUpdates[i]();
        }
      });
    }
  },

  calculateMaximumDiscount(markdownObject, priceEl) {
    const productColl = priceEl.data("product-coll");
    if (!productColl) return 1;

    const collections = productColl.split(",");
    let minMultiplier = 1;

    for (let i = 0; i < markdownObject.length; i++) {
      const object = markdownObject[i];
      const objectCollections = object.markdown_collections.split(",");
      for (let j = 0; j < objectCollections.length; j++) {
        if (collections.includes(objectCollections[j])) {
          const multiplier = Number(object.markdown_multiplier);
          if (multiplier < minMultiplier) {
            minMultiplier = multiplier;
          }
          break;
        }
      }
    }
    return minMultiplier;
  },

  additionalPrice(item) {
    const isfivePack = item.product_type === "1-Pack" && item.quantity === 5;
    if (!isfivePack) {
      return 0;
    }

    let unitPackDiscount = 1500;
    if (item.tags.includes("ankle-socks")) {
      unitPackDiscount = 800;
    } else if (item.tags.includes("aerolite-plus-collection")) {
      unitPackDiscount = 1650;
    }
    return unitPackDiscount;
  },

  getDiscountPrice(markdownObject, item) {
    let itemPrice = item.original_line_price - this.additionalPrice(item);
    let markdownApplied = false;
    let doNotOverwrite = false;
    markdownObject.forEach((object) => {
      if (!object.markdown_include_in_subtotal) {
        return;
      }

      let multiplier = Number(object.markdown_multiplier);
      const mode = object.markdown_mode;
      const markdown_variants = object.markdown_variants || [];

      const collections = object.markdown_collections.split(",");
      const hasMatchingCollection = item.product_collections.some((col) =>
        collections.includes(col)
      );

      if (markdown_variants.length) {
        let selectedSize = item.variant_title;

        if (selectedSize) {
          const selectedVariant = markdown_variants.find((variant) => {
            const variantSizes = variant.titles.map((title) =>
              title.toLowerCase()
            );
            return variantSizes.includes(selectedSize.toLowerCase());
          });

          if (selectedVariant && selectedVariant.multiplier) {
            multiplier = Number(selectedVariant.multiplier);
          }
        }
      }

      if (hasMatchingCollection) {
        let markdown_code = object.markdown_discount_code;
        if (markdown_code == "LASTCHANCE40") {
          markdown_code = "LASTCHANCE";
        }

        const discounted_item = item.line_level_discount_allocations.find(
          (allocation) =>
            allocation.discount_application?.title == markdown_code
        );
        if (discounted_item) {
          itemPrice = item.final_line_price;
          multiplier = 1;
        }

        // BFCM change
        if (object.markdown_overwrite_others) {
          itemPrice = item.original_line_price;
        }

        if (!doNotOverwrite) {
          itemPrice =
            mode === "subtract"
              ? itemPrice -
                Math.floor(
                  multiplier *
                    currency_conversion[user_currency] *
                    item.quantity
                ) *
                  100
              : itemPrice * multiplier;
        }
        if (object.markdown_overwrite_others) {
          doNotOverwrite = true;
        }
        markdownApplied = true;
      }
    });
    item.calculated_discount_price = itemPrice;
    item.markdown_applied = markdownApplied;
    return item;
  },

  calculateCartDiscount(cartItems) {
    const all = [...cartItems];
    const markdownObject = localStorageUtils.get("markdown_object") || [];
    const self = this;
    const discounted = [];
    markdownObject.forEach((object) => {
      const discountCode = object.markdown_discount_code;
      if (object.markdown_initialized !== "initialized") return;
      if (object.markdown_auto_apply_coupon && discountCode) {
        autoApplyCouponCode(discountCode);
      }
    });

    cartItems = cartItems.filter((curr) => {
      const item = self.getDiscountPrice(markdownObject, curr);
      if (item.markdown_applied) {
        discounted.push({
          title: item.title,
          id: item.id,
          price: Math.round(item.calculated_discount_price),
          collections: item.product_collections,
        });
        return false;
      }
      return true;
    });

    const eligibleDiscounted = discounted.filter(
      (item) => !item.collections.includes("promo-rx")
    );
    const discountedPrice = discounted.reduce(
      (prev, curr) => prev + curr.price,
      0
    );
    const eligibleDiscountedPrice = eligibleDiscounted.reduce(
      (prev, curr) => prev + curr.price,
      0
    );
    const othersPrice = cartItems.reduce(
      (prev, curr) =>
        prev + curr.original_line_price - self.additionalPrice(curr),
      0
    );
    const totalPrice = all.reduce(
      (prev, curr) => prev + curr.original_line_price,
      0
    );
    const markdown_price = othersPrice + discountedPrice;
    const eligible_price = othersPrice + eligibleDiscountedPrice;
    const formatter = new Intl.NumberFormat("en-US", {
      style: "decimal",
      currency: user_currency,
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
      useGrouping: !1,
    });
    const original = formatter.format(totalPrice);
    const markdown = formatter.format(markdown_price);
    const eligible = formatter.format(eligible_price);

    return { original, markdown, eligible };
  },

  calculateCart(cartItems) {
    const { markdown, original, eligible } =
      this.calculateCartDiscount(cartItems);

    if (Number(markdown) < Number(original)) {
      setTimeout(() => {
        let subTotalEl = $('.Cart__Checkout span[data-id="cart-total"]');
        if (!subTotalEl.length) {
          subTotalEl = $(".Cart__Checkout");
        }
        // subTotalEl.html(
        //   `<span data-value="markdown_price"><span class="money markdown-price">$${(
        //     markdown / 100
        //   ).toFixed(2)}</span><span class="old_money">$${(
        //     original / 100
        //   ).toFixed(2)}</span></span>`
        // );
        $(".Cart__Checkout").data("discounted-price", eligible);
      }, 100);
    }
  },
};

// Multi-tier promotional framework
class MultiTierPromotionalFramework {
  constructor(options = {}) {
    this.options = options;
    this.promotions = options.promotions || [];
    this.defaultPromoConfig = {
      multiplier: 1,
      collections: [],
      subtract: false,
      id: "test",
      autoApplyCoupon: false,
      expires: 3,
      variants: [],
      enable_markdown: true,
    };
    this.init();
  }
  init() {
    this.promotionList = this.promotions.map((promotion) => {
      return {
        ...this.defaultPromoConfig,
        ...promotion,
      };
    });

    this.applyPromotions();

    document.addEventListener("collection:filters:applied", () => {
      // Fresh span.Price elements from AJAX filter results — same two-pass
      // approach as page load: subtract first, then multiply overwrite.
      MarkdownPricePro.run();
      requestAnimationFrame(() => {
        MarkdownPricePro.run({ overwriteOthers: true, skipSubtract: true });
      });
    });

    document.addEventListener("color-dot:changed", () => {
      // After a dot swap the price element is reset to span.Price — use the
      // same two-pass approach so july-4th-sale stacks correctly on subtract.
      MarkdownPricePro.run();
      requestAnimationFrame(() => {
        MarkdownPricePro.run({ overwriteOthers: true, skipSubtract: true });
      });
    });

    console.log("Multi-tier promotional framework");
  }

  applyPromotions() {
    setTimeout(() => {
      MarkdownPricePro.upsert({
        markdowns: this.promotionList,
        apply: true,
      });
    }, 100);
  }
}

const BFCM_PROMOTIONS = {
  promotions: [
    {
      multiplier: 0.74,
      collections: ["eoy-tier-29"],
      id: "eoy-tier-29",
      disabled: true,
    },
    {
      multiplier: 0.66,
      collections: ["eoy-tier-34"],
      id: "eoy-tier-34",
      disabled: true,
    },
    {
      multiplier: 0.59,
      collections: ["eoy-tier-41"],
      id: "eoy-tier-41",
      disabled: true,
    },
    {
      multiplier: 0.54,
      collections: ["eoy-tier-46"],
      id: "eoy-tier-46",
      disabled: true,
    },
    {
      multiplier: 0.4,
      collections: ["eoy-tier-60"],
      id: "eoy-tier-60",
      disabled: true,
    },
    {
      multiplier: 0.85,
      collections: ["nyp-tier-15"],
      id: "nyp-tier-15",
      disabled: true,
    },
    {
      multiplier: 0.76,
      collections: ["nyp-tier-24"],
      id: "nyp-tier-24",
      disabled: true,
    },
    {
      multiplier: 0.73,
      collections: ["nyp-tier-27"],
      id: "nyp-tier-27",
      disabled: true,
    },
  ],
};

new MultiTierPromotionalFramework(BFCM_PROMOTIONS);

const COOKIE_KEYS = {
  CURRENT_PROMOTION: "currentPromotion",
  VANITY: "vanity_in_cookie",
  PROMOTIONAL_MARKDOWN: "promotional-markdown",
  VANITY_MARKDOWN: "vanity-markdown",
  AT20_MARKDOWN: "at20-markdown",
};

(function ($) {
  const dis_codes = [];
  let static_map = {};
  let col_map = { ...globalThis.themeVariables.collections, ...static_map };
  class VanityURL {
    constructor() {
      this.stringParams = ["vu_tb", "vu_splm", "vu_cr", "vu_ctm", "vu_acm"];
      this.arrayParams = ["vu_col"];
      this.intParams = ["vu_atemp", "vu_temp", "vu_dis", "vu_tl"];
      this.invalidCouponCodes = ["clear", "false"];
      this.AB_Distribution = {
        0: 0.0,
        1: 0.05,
        2: 0.1,
        3: 0.2,
        4: 0.3,
        5: 0.4,
        6: 0.5,
      };
      this.cookieExpiry = 1;
      this.selectors = {
        promoCodeSelector: `data-promotion-id="promotion-cart-code-instruction"`,
        specialMessage: ".specialMessage",
        couponReminder: ".coupon-reminder",
        discountMessage: "discount-message",
        announcementBar: ".AnnouncementBar__Content",
        announcementSection: "#section-announcement",
        pdpBox: ".pdp-box",
        mysteryCartItems: ".mystery-cart-items",
        checkoutMessage: "#checkoutmessage",
        basketRight: "#basket-right",
        cartSpecialMessage: "#basket-right .special-offerTags",
        productSpecialMessage: ".pdp-box .special-offerTags",
        attentiveTimer: "#AttentiveTimer",
      };
      this.vo = {
        vu_init: 0,
        vu_cc: !1,
        vu_dis: 0,
        vu_col: ["shop-all"],
        vu_dt: 0,
        vu_tl: 1,
        vu_ul: 1,
        vu_gif: 0,
        vu_exp: 0,
        vu_gt: "",
        vu_uc: "shop-all",
        vu_ctm: "Your offer is going to expire in",
        vu_st: 0,
        vu_ac: 0,
        vu_acm: "",
        vu_nx: 0,
        vu_atemp: 1,
        vu_temp: 1,
        vu_ab_cntrl: 1,
        vu_pdp: 0,
        vu_tb: "",
        vu_splm: "",
        vu_up2: 1,
        vu_mp: 1,
        vu_cr: "",
      };
      this.actionsMap();
    }
    actionsMap() {
      const self = this;
      const {
        mysteryCartItems,
        specialMessage,
        checkoutMessage,
        promoCodeSelector,
        couponReminder,
        basketRight,
      } = this.selectors;
      this.actions = {
        vu_up2: function () {
          if (self.vo.vu_up2 == 0) $(checkoutMessage).remove();
        },
        vu_mp: function () {
          const vu_mp = self.vo.vu_mp;
          $(mysteryCartItems).toggle(vu_mp && vu_mp > 0);
        },
        vu_splm: function () {
          const vu_splm = self.vo.vu_splm;
          if (!vu_splm) {
            return;
          }
          const text = vu_splm.indexOf("|") > -1 ? vu_splm.split("|") : vu_splm;
          const promoCodeElem = $(`div[${promoCodeSelector}]`);
          if (!promoCodeElem.length) {
            return;
          }
          $(specialMessage).remove();
          promoCodeElem.before(
            self.getSpecialMessage({
              classname: "specialMessage",
              heading: Array.isArray(text)
                ? text[0].replaceAll("percent", "%")
                : "",
              paragraph: Array.isArray(text)
                ? text[1].replaceAll("percent", "%")
                : text,
              specialSelector: promoCodeSelector,
            })
          );
        },
        vu_cr: function () {
          const vu_cr = self.vo.vu_cr;
          if (!vu_cr) {
            return;
          }
          const text = vu_cr.split("|");
          if (!$(basketRight).length) {
            return;
          }
          $(couponReminder).remove();
          $(basketRight).prepend(
            self.getSpecialMessage({
              classname: "coupon-reminder",
              heading: text[0].replaceAll("percent", "%"),
              paragraph: text[1].replaceAll("percent", "%"),
              specialSelector: "",
            })
          );
        },
        vu_gif: self.updateGiftBox.bind(self),
        vu_pdp: self.showPdpBox.bind(self),
      };
    }
    getAllParams() {
      let data = {};
      for (const key in this.vo) {
        if (Object.hasOwnProperty.call(this.vo, key)) {
          data[key] = Cookies.get(key) || this.vo[key];
        }
      }
      return data;
    }
    getSpecialMessage({ classname, heading, paragraph, specialSelector }) {
      return `
			<div ${specialSelector} class="special-offerTags ${classname}" style="">
				<div>
					<h3><strong>${heading}</strong></h3>
					<p>${paragraph}</p>
				</div>
			</div>`;
    }
    getPromoCollections(collections = this.vo.vu_col) {
      return collections
        .map((h) => (col_map[h] ? col_map[h].title : ""))
        .join(", ");
    }
    getData(key) {
      const value = this.vo[key];
      return this.intParams.includes(key) ? parseInt(value) : value;
    }
    setData(key, value, expires = 1, setcookie = true) {
      this.vo[key] = this.arrayParams.includes(key)
        ? decodeURIComponent(value).split(",")
        : this.intParams.includes(key)
        ? parseInt(value)
        : value;
      if (!setcookie) {
        return;
      }
      setCookieWithExpiry(key, value, expires);
    }
    showDiscountMessage() {
      let m = "";
      const { vu_atemp, vu_tl, vu_cc } = this.vo;
      const { discountMessage } = this.selectors;
      const { template } = globalThis.themeVariables;
      switch (vu_atemp) {
        case 1:
          m =
            (vu_tl > 1 ? `MINIMUM ${vu_tl} ITEMS IN CART: ` : "") +
            `ALL PRICING DISPLAYED ARE DISCOUNTED PRICE WITH ${vu_cc} COUPON CODE`;
          break;
        default:
          m =
            (vu_tl > 1 ? `MINIMUM ${vu_tl} ITEMS IN CART: ` : "") +
            `ALL PRICING DISPLAYED ARE DISCOUNTED PRICE WITH ${vu_cc} COUPON CODE`;
          break;
      }
      this.setData("vu_acm", m);
      $(`.${discountMessage}`).remove();
      const tag_copy = `
			<div class="${discountMessage}">
				<span id="countryDutyFreeText">${m}</span>
			</div>`;
      if (template.includes("cart")) {
        $("form.Cart").before(tag_copy);
      } else if (template.includes("index")) {
        $(".shopify-section--slideshow").after(tag_copy);
      } else {
        $(".page-header-collection").after(tag_copy);
      }
    }
    showTopbarMessage() {
      let m = "";
      const { announcementBar, announcementSection } = this.selectors;
      const { vu_temp, vu_cc, vu_tl, vu_col, vu_dis, vu_dt, vu_tb } = this.vo;
      const collections = this.getPromoCollections();
      const discount = vu_dt == 1 ? `$${vu_dis}` : `${vu_dis}%`;
      switch (vu_temp) {
        case 1:
          m =
            `${discount} OFF ` +
            (vu_tl > 1 ? `${vu_tl}+ PAIRS` : "") +
            ` FROM ${collections} | CODE: ${vu_cc}`;
          break;
        case 2:
          m =
            `SPECIAL OFFER : ${discount} OFF ` +
            (vu_tl > 1 ? `${vu_tl}+ PAIRS` : "") +
            ` FROM ${collections}`;
          break;
        case 3:
          m = `Fall Sale: ${discount} OFF Sitewide`;
          break;
        case 4:
          m = `Summer Exclusive: ${discount} OFF ALL SHADES`;
          break;
        case 5:
          m =
            `${discount} OFF SITEWIDE` +
            (vu_tl > 1 ? `${vu_tl}+ PAIRS` : "") +
            ` | CODE: ${vu_cc}`;
          break;
        case 6:
          m = vu_tb;
          break;
        case 7:
          m = ` <a href='/collections/last-chance-collection'> SPECIAL OFFER : ${discount} OFF ON Last Chance Collection</a>`;
          break;
        case 8:
          m = `SAVE ${discount} WITH WELLOW’S LABOR DAY SALE!`;
          break;
        case 9:
          m = `Black Friday • ${discount} OFF SITEWIDE • <a href='/collections/womens-compression-socks'>SHOP WOMEN</a> • <a href='/collections/mens-compression-socks'>SHOP MEN</a>`;
          break;
        case 10:
          m = `Early access • Last sale of the year • ${discount} off sitewide • <a href='/collections/womens-compression-socks'>shop now</a>`;
          break;
        default:
          m =
            `${discount} OFF ` +
            (vu_tl > 1 ? `${vu_tl}+ PAIRS` : "") +
            ` FROM ${collections} | CODE: ${vu_cc}`;
          break;
      }
      $(announcementBar).html(`<b>${m}</b>`);
      if (vu_cc === "FRESHSTART") {
        $(announcementSection).css("background", "#CA2C3B");
      }
      this.setData("vu_tb", m);
    }
    stop() {
      this.vo.vu_init = 0;
      for (let key in this.vo) {
        Cookies.remove(key);
      }
      setCookieWithExpiry(COOKIE_KEYS.VANITY, !1, 1.5);
      MarkdownPricePro.clear(COOKIE_KEYS.VANITY_MARKDOWN);
      const currentPromotion = Cookies.get(COOKIE_KEYS.CURRENT_PROMOTION);
      if (currentPromotion == "SPRING") {
        Cookies.remove(COOKIE_KEYS.CURRENT_PROMOTION);
      }
    }
    initMarkdown() {
      const { vu_dt, vu_dis, vu_cc, vu_col } = this.vo;
      const discount = vu_dt == 1 ? vu_dis : 1 - vu_dis / 100;
      MarkdownPricePro.init({
        discount_code: vu_cc,
        multiplier: discount,
        collections: vu_col,
        subtract: vu_dt == 1,
        id: COOKIE_KEYS.VANITY_MARKDOWN,
      });
    }
    callActions() {
      const self = this;
      const { vu_cc, vu_ac, vu_gif } = this.getAllParams();
      const { mysteryCartItems } = this.selectors;
      for (let key in this.actions) {
        if (this.actions.hasOwnProperty(key) && this.vo[key]) {
          this.actions[key]();
        }
      }
      $(document).on("cart:replaceContent", function (event) {
        const cart = getCart(event);
        if (self.vo.vu_cc !== "LASTCHANCE") {
          self.showMessage(cart);
        }
        $(mysteryCartItems).toggle(self.vo.vu_mp > 0);
        self.showPdpBox(cart);
        MarkdownPricePro.run();
      });
      if (vu_cc) {
        if (vu_ac == 1) {
          this.showDiscountMessage();
        }
        this.showTopbarMessage();
        this.initMarkdown();
      }
    }
    itemsCounts(cart) {
      const self = this;
      return cart.items
        .filter(function (i) {
          let comman = $.grep(self.vo.vu_col, function (e) {
            return i.properties && $.inArray(e, i.product_collections) !== -1;
          });
          return comman.length;
        })
        .map((item) => item.quantity)
        .reduce((prev, curr) => prev + curr, 0);
    }
    getUpsell2Message(cartdata = null) {
      return "";
      const cart = cartdata || getCart();
      if (!cartdata.items.length) return "";
      const {
        vu_dt,
        vu_dis: current_discount,
        vu_cc,
        vu_tl: threshold,
        vu_nx,
      } = this.vo;
      let m = `<div class="Drawer__Container"><div class="CartItem">`;
      if (!cart || this.invalidCouponCodes.includes(vu_cc)) {
        return m + `</div></div>`;
      }
      const discount =
        vu_dt == 1 ? `$${current_discount}` : `${current_discount}%`;
      const collections = this.getPromoCollections();
      const actual_cart_items = this.itemsCounts(cart);
      const specialMessageContent = function ({ heading, paragraph }) {
        return `
        <div class="message-banner">
            <h3><strong>${heading}</strong></h3>
            <p>${paragraph}
                <br><small><em>Offer cannot be combined with other coupons</em></small>
            </p>
        </div>`;
      };
      if (vu_nx == 0) {
        if (actual_cart_items >= threshold) {
          m += specialMessageContent({
            heading: "DEAL MET!",
            paragraph: `Use Code: <strong>${vu_cc}</strong> at checkout for ${discount} off.`,
          });
        } else {
          m += specialMessageContent({
            heading: "Only One Pair?",
            paragraph: `Grab one more pair from <span style="text-decoration: underline">${collections}</span> for <strong>${discount} OFF</strong> both pairs!`,
          });
        }
      } else {
        const up_2 = dis_codes.filter((x) => x.dis > current_discount);
        if (!up_2.length) {
          return m + `</div></div>`;
        }
        if (actual_cart_items >= threshold + 1) {
          m += specialMessageContent({
            heading: "DEAL MET!",
            paragraph: `Use Code: <strong>${up_2[0].code}</strong> at checkout for ${up_2[0].dis}% off.`,
          });
        } else {
          m += specialMessageContent({
            heading: "Only One Pair?",
            paragraph: `Grab one more pair from <span style="text-decoration: underline">${collections}</span> for <strong>${up_2[0].dis}% OFF</strong> both pairs!`,
          });
        }
      }
      m += `</div></div>`;
      return m;
    }
    showMessage(cart) {
      const { cartSpecialMessage, basketRight } = this.selectors;
      $(cartSpecialMessage).remove();
      $(basketRight).prepend(this.getUpsell2Message(cart));
    }
    showPdpBox(cart) {
      const { productSpecialMessage, pdpBox } = this.selectors;
      $(productSpecialMessage).remove();
      $(pdpBox).empty();
      if (this.vo.vu_pdp == 1) {
        $(pdpBox).html(this.getUpsell2Message(cart));
      }
    }
    updateGiftBox() {
      const { vu_gif, vu_splm, vu_uc, vu_gt, vu_ul } = this.getAllParams();
      const free_item = user_cart_items.filter(
        (x) => x.id == vu_gif && x.line_price == 0
      );
      const { promoCodeSelector, specialMessage } = this.selectors;
      if (!vu_splm && !free_item.length) {
        const promoCodeElem = $(`div[${promoCodeSelector}]`);
        if (!promoCodeElem.length) {
          return;
        }
        const collections = this.getPromoCollections(vu_uc.split(","));
        $(specialMessage).remove();
        promoCodeElem.before(
          this.getSpecialMessage({
            classname: "specialMessage",
            heading: "Free Gift!",
            paragraph: `Get free <strong>${decodeURI(
              vu_gt
            )}</strong> on purchase of any ${vu_ul} items from <span style="text-decoration:underline;">${collections}</span>`,
            specialSelector: "",
          })
        );
      }
    }
    getTimeRemaining(endtime) {
      const total = Date.parse(endtime) - Date.parse(new Date());
      const seconds = Math.floor((total / 1000) % 60);
      const minutes = Math.floor((total / 1000 / 60) % 60);
      const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
      const days = Math.floor(total / (1000 * 60 * 60 * 24));
      return { total, days, hours, minutes, seconds };
    }
    initializeClock() {
      const self = this;
      const { attentiveTimer: timer } = this.selectors;
      const endtime = new Date(
        Date.parse(self.vo.vu_exp) + 0 * 24 * 60 * 60 * 1000
      );
      function sliceTime(val) {
        return ("0" + val).slice(-2);
      }
      function updateClock() {
        const t = self.getTimeRemaining(endtime);
        let timeleft = `${t.days}D ${sliceTime(t.hours)}H ${sliceTime(
          t.minutes
        )}M ${sliceTime(t.seconds)}S`;
        if (t.days == 0) {
          if (t.hours >= 1) {
            timeleft = `${sliceTime(t.hours)}:${sliceTime(
              t.minutes
            )}:${sliceTime(t.seconds)}`;
          } else {
            timeleft = `${sliceTime(t.minutes)}:${sliceTime(t.seconds)}`;
          }
        }
        $(timer)
          .find("span")
          .html(`${self.vo.vu_ctm} <span class="timeleft">${timeleft}</span>`);
        $(timer).show();
        if (t.total <= 0) {
          clearInterval(timeinterval);
        }
      }
      updateClock();
      const timeinterval = setInterval(updateClock, 1000);
    }
    gaTrack(str) {
      let retryCounter = 0;
      function checkIfAnalyticsLoaded() {
        if ((typeof ga === "function" && ga.loaded) || retryCounter++ > 20) {
          gtag("event", "vanity_event", { Vanity: str });
          console.log("ga loaded");
        } else {
          setTimeout(checkIfAnalyticsLoaded, 2000);
        }
      }
      checkIfAnalyticsLoaded();
    }
    run() {
      const { vu_cc, vu_exp, vu_st, vu_init, vu_ab_cntrl } = this.vo;
      const { template } = globalThis.themeVariables;
      setCookieWithExpiry(COOKIE_KEYS.CURRENT_PROMOTION, "clear", 1);
      if (vu_init != 1) {
        return this.stop();
      }
      setCookieWithExpiry(COOKIE_KEYS.VANITY, !0, this.cookieExpiry);

      const isABTestActive = Cookies.get("ab_test_active") == "true";
      const percentage = this.AB_Distribution[vu_ab_cntrl];

      if (isABTestActive || (vu_cc && Math.random() < percentage)) {
        autoApplyCouponCode(vu_cc);
        MarkdownPricePro.clear(COOKIE_KEYS.VANITY_MARKDOWN);

        try {
          this.gaTrack(`Control - ${vu_cc}`);
        } catch (error) {
          console.log("ga not loaded");
        }
      } else {
        if (vu_exp) {
          const current_date = new Date();
          const expiry_date = new Date(vu_exp);
          if (current_date > expiry_date) {
            return this.stop();
          }
          if (vu_st == 1 && !template.includes("cart")) {
            this.initializeClock();
          }
        }
        this.callActions();
        try {
          this.gaTrack(`Experiment ${vu_cc}`);
        } catch (error) {
          console.log("ga not loaded");
        }
      }
    }
    updateCookies(type) {
      let vo = this.vo;
      const vu_exp = getUrlParam("vu_exp", !1) || Cookies.get("vu_exp");
      const setcookie = type !== 3;
      const expires = vu_exp
        ? (new Date(vu_exp) - new Date()) / (1000 * 60 * 60 * 24)
        : this.cookieExpiry;

      for (let key in vo) {
        if (Object.hasOwnProperty.call(vo, key)) {
          let value = type == 1 ? getUrlParam(key, !1) : Cookies.get(key);
          if (value) {
            if (this.stringParams.indexOf(key) > -1) {
              value = decodeURI(
                value
                  .replace(/\%2B/g, "+")
                  .replace(/%(?![0-9][0-9a-fA-F]+)/g, "%25")
              );
            }
            if (
              key == "vu_col" &&
              value.includes("shop-all") &&
              !value.includes("daily-wellness-kits")
            ) {
              value = value.split(",").concat("daily-wellness-kits").join(",");
            }
            this.setData(key, value, expires, setcookie);
          } else {
            Cookies.remove(key);
          }
        }
      }

      this.run();
    }
    checkAndOverwrite(vanityInCookie) {
      if (!vanityInCookie) {
        return this.updateCookies(1);
      }

      const urlDiscount = Number(getUrlParam("vu_dis", 0));
      const savedDiscount = Number(Cookies.get("vu_dis"));

      if (urlDiscount >= savedDiscount) {
        return this.updateCookies(1);
      }
    }
    init() {
      console.info("Vanity URL initiated");
      // Vanity URL framework fully disabled. Always clear any stored vanity
      // cookies + markdown and never activate — so returning visitors who still
      // carry vanity cookies get wiped and no vanity discount is ever applied.
      // (stop() removes every vu_* cookie + the VANITY cookie and clears the
      // vanity-markdown.) The original logic below is intentionally unreachable.
      // return this.stop();
      const { vu_cc: couponCode } = this.vo;

      // Check for invalid coupon codes first
      if (this.invalidCouponCodes.includes(couponCode)) {
        return this.stop();
      }

      // First check vanity parameters in URL
      const vuInitParam = getUrlParam("vu_init", null);
      const hasVanityInURL = vuInitParam !== null;
      let vanityInCookie = Cookies.get(COOKIE_KEYS.VANITY) || !1;
      vanityInCookie = vanityInCookie && vanityInCookie === "true";

      if (hasVanityInURL) {
        // If vu_init is set to 0 or false in URL, clear all vanity cookies and markdown
        if (
          vuInitParam === "0" ||
          vuInitParam === "false" ||
          vuInitParam == 0 ||
          vuInitParam === false ||
          vuInitParam === "clear"
        ) {
          return this.stop();
        }

        // Vanity parameter available in URL, save in cookies
        return this.checkAndOverwrite(vanityInCookie);
      }

      // No vanity parameter in URL, check for vanity in cookie
      if (vanityInCookie) {
        // Vanity available in cookie, update cookies
        this.updateCookies(3);
      } else {
        // No vanity in URL or cookie, stop
        this.stop();
      }
    }
    vanityCode() {
      return ({
        vu_init: active,
        vu_dis: discount,
        vu_col: collection,
        vu_nx: upgrade,
      } = this.vo);
    }
  }

  $.Promotion = function (primary_code = "") {
    this.promotionsList = promo_obj;
    this.forcedPromo = promo_obj.forcedDefaultPromo || !1;
    this.forcedPromoObject = this.promotionsList[this.forcedPromo];
    this.currentPromotionObj = {};
    this.defaultPromo = this.promotionsList.default;
    this.useSlider = document.body.classList.contains("cross-sell-slider-ab-test");
    this.lastCrossSellSlideIndex = null;
    this.promoApplied = !1;
    this.productAdded = !1;
    this.cookieExpiry = 3;
    this.WIDECALF_TAG = "widecalf";
    this.selectors = {
      announcement: "#section-announcement",
      bar: ".AnnouncementBar__Content",
      cart_banner: ".cart-promo-banner img",
      cart_html: ".cart-promo-html",
      cart_form: 'form[action="/cart"]',
      cross_sell: ".promo.CrossSellWrapper",
      default_cross_sell: ".default.CrossSellWrapper",
      option_swatch: ".CrossSell .SwatchList input",
      continue_shopping: ".add-one-more-block",
      upsell_modal: "#upsell-modal",
      packSwatchRadio: ".PackSwatch__Radio",
      productMetaTitle: ".ProductMeta__Title",
      variantSelector: 'select[name="id"]',
      productFormLabel: ".ProductForm__Label",
      freeGiftItemAttr: "[data-free-gift-true]",
    };
    this.setCurrentPromotion(primary_code);
    this.setReviewsCookie();
  };
  $.Promotion.prototype = {
    InitEvents: function () {
      const self = this;
      const {
        option_swatch,
        upsell_modal,
        packSwatchRadio,
        productMetaTitle,
        variantSelector,
        productFormLabel,
        freeGiftItemAttr,
      } = self.selectors;
      $(document).on("product:added", function (event) {
        self.productAdded = !0;
      });
      $(document).on("quantity:updated", function (event) {
        self.productAdded = !0;
      });
      $(document).on("variant:changed", function (event) {
        MarkdownPricePro.run();
        requestAnimationFrame(() => {
          MarkdownPricePro.run({ overwriteOthers: true, skipSubtract: true });
        });
      });
      $(document).on("change", packSwatchRadio, function () {
        MarkdownPricePro.run();
      });
      $(document).on(
        "cart:replaceContent",
        this.onCartContentReplacement.bind(self)
      );
      // Watch for Convert Experience adding/removing the A/B body class after page load
      new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.attributeName !== "class") return;
          const hasClass = document.body.classList.contains("cross-sell-slider-ab-test");
          if (hasClass === self.useSlider) return; // no change, skip
          self.useSlider = hasClass;
          const cart = getCart();
          self._injectDefaultCrossSell(cart);
        });
      }).observe(document.body, { attributes: true, attributeFilter: ["class"] });
      $(document).on(
        "click",
        '#upsell-modal [data-action="close-modal"]',
        function (e) {
          e.preventDefault();
          $(upsell_modal).attr("aria-hidden", !0);
        }
      );
      $(document).on("click", ".open-upsell-modal", function (e) {
        e.preventDefault();
        $(upsell_modal).attr("aria-hidden", !1);
      });
      $(document).on("change", option_swatch, function (e) {
        let selectedOptions = [];
        const cart = getCart();
        const $this = $(e.target);
        const wrapper = $this.closest(".CrossSellWrapper");
        const isDefaultPromoItem = wrapper.hasClass("default");
        const promo = isDefaultPromoItem
          ? self.defaultPromo
          : self.currentPromotionObj;
        let defaultUpsellItem = promo.upsell_item;
        $(".Modal__ErrorAlert").remove();
        if (isDefaultPromoItem) {
          if (self.containsWidecalfItem(cart)) {
            defaultUpsellItem = promo.widecalf_mystery || promo.upsell_item;
          }
        }
        const variants = defaultUpsellItem?.variants;
        for (let i = 0; i < 3; i++) {
          const val =
            wrapper.find(`[name="option-${i}"]:checked`).val() || null;
          selectedOptions.push(val);
        }
        const selectedVariant = self._getCurrentVariantFromOptions(
          selectedOptions,
          variants
        );
        wrapper.find(variantSelector).val(selectedVariant.id).trigger("change");
        wrapper.find(productFormLabel).text(`Size: ${selectedVariant.title}`);
      });
      $(document).ready(function ($) {
        var $sectionHeader = $('#section-header[data-onscroll-sticky="true"]');
        function debounce(func, wait, immediate) {
          var timeout;
          return function () {
            var context = this,
              args = arguments;
            var later = function () {
              timeout = null;
              if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
          };
        }
        $(window).scroll(
          debounce(function () {
            var scroll = $(window).scrollTop();
            if (scroll >= 40) {
              $sectionHeader.addClass("sticky-header");
            } else {
              $sectionHeader.removeClass("sticky-header");
            }
          }, 10)
        );
      });
      $(document).on(
        "click",
        ".CrossSell_AddButton",
        this.addCrossSellItem.bind(this)
      );

      // Cross-sell slider: color dot change handler
      $(document).on("change", ".cs-color-input", function () {
        const $input   = $(this);
        const $slide   = $input.closest(".Carousel__Cell, .mystery-cart-container");
        const isMystery = String($input.data("isMystery")) === "true";
        // Keep the slide's own flag in sync — addCrossSellItem reads it fresh
        // via .attr() (not .data()) at add-to-cart time, since the color the
        // shopper lands on can differ from the one the slide was rendered with.
        $slide.attr("data-is-mystery", isMystery);
        const price    = parseInt($input.data("productPrice"), 10);
        const compare  = parseInt($input.data("productComparePrice"), 10);
        const coll     = $input.data("productColl") || "";
        const pack     = parseInt($input.data("productPack"), 10) || 1;

        // 1 – Update product image
        $slide.find(".cs-slide-image").attr("src", $input.data("productImage"));

        // 2 – Update subtitle
        $slide.find(".cs-slide-subtitle").text($input.data("productSubtitle"));

        // 3 – Update price element data attrs & inner HTML
        const $prices = $slide.find(".prices-col");
        if (!isMystery) {
          $prices
            .attr("data-product-coll", coll)
            .attr("data-price", price)
            .attr("data-compare-price", compare)
            .attr("data-pack-size", pack);
          if (compare > price) {
            $prices.attr("data-discounted-price", price);
          } else {
            $prices.removeAttr("data-discounted-price");
          }
        }

        const fmt = function (cents) {
          const val = (cents / 100).toFixed(2);
          return "$" + (val.endsWith(".00") ? val.slice(0, -3) : val);
        };

        let priceHtml;
        if (!isMystery && compare > price) {
          priceHtml =
            `<span class="cross-sell-sale-price Price Price--highlight Text--subdued" data-price="${price}" data-compare-price="${fmt(compare)}">${fmt(price)}</span>` +
            `<span class="cross-sell-compare-price Price old-price">${fmt(compare)}</span>`;
        } else {
          const cls = isMystery ? "cross-sell-sale-price" : "cross-sell-sale-price Price Text--subdued";
          priceHtml = `<span class="${cls}" data-price="${price}">${fmt(price)}</span>`;
        }
        $prices.html(priceHtml);
        refreshMysteryPairSalePrices();

        // 4 – Rebuild size <select> from compact variant JSON
        const variants = $input.data("variants"); // jQuery auto-parses JSON arrays
        const $select  = $slide.find(".SizeSwatch--select");
        if (Array.isArray(variants) && variants.length) {
          let firstAvailId = null;
          let opts = "";
          variants.forEach(function (v) {
            if (v.available && firstAvailId === null) firstAvailId = v.id;
            const sel  = firstAvailId === v.id ? ' selected="selected"' : "";
            const dis  = v.available ? "" : ' disabled="disabled"';
            opts += `<option value="${v.id}" data-sku="${v.sku || ""}"${sel}${dis}>${v.title}</option>`;
          });
          $select.html(opts);
        }

        // 5 – Re-apply markdown (two-pass) unless mystery pair
        if (!isMystery) {
          MarkdownPricePro.run();
          requestAnimationFrame(function () {
            MarkdownPricePro.run({ overwriteOthers: true, skipSubtract: true });
          });
        }
      });

      this.applyCustomPromotion();
    },
    containsWidecalfItem(cart) {
      return cart.items.find((i) => i.tags.indexOf(this.WIDECALF_TAG) > -1);
    },
    _injectDefaultCrossSell(cart) {
      const { default_cross_sell, option_swatch } = this.selectors;
      const dp = this.defaultPromo;
      const widecalfItem = this.containsWidecalfItem(cart);
      const sliderHtml = dp?.cross_sell_slider_html;
      const singleHtml = dp?.cross_sell_html;
      const activeHtml = this.useSlider && sliderHtml ? sliderHtml : singleHtml;
      const upsellItemMarkup = widecalfItem
        ? dp?.widecalf_mystery_html ?? activeHtml
        : activeHtml;
      if (dp?.add_automatically) return;

      if (this.useSlider) {
        this._injectCrossSellSlider(cart, upsellItemMarkup);
        return;
      }

      const dpIds = [
        ...this.getVariantIds(dp?.upsell_item?.variants || []),
        ...this.getVariantIds(dp?.widecalf_mystery?.variants || []),
      ];
      const defaultPromoApplied = cart.items.some((item) =>
        dpIds.includes(item.variant_id)
      );
      if (!defaultPromoApplied) {
        $(default_cross_sell).html(upsellItemMarkup);
        const variantTitles = cart.items.map((item) => item.variant_title);
        const mostFrequent = this.mostFrequent(variantTitles);
        let swatch = $(`${option_swatch}[value="${mostFrequent}"]`);
        if (!swatch.length || swatch.prop("disabled")) {
          swatch = $(`${option_swatch}:not([disabled])`).first();
        }
        swatch.prop("checked", !0).trigger("change");
        refreshMysteryPairSalePrices();
      }
    },
    // A color option is already bought once any of its size variants is in the cart.
    _crossSellVariantsInCart(variants, cartVariantIds) {
      return Array.isArray(variants) && variants.some((v) => cartVariantIds.includes(v.id));
    },
    // Multi-product cross-sell slider: rather than hiding the whole carousel once one
    // item has been added, keep it around — remove the color dot that was just bought,
    // drop a slide entirely once it has nothing left to offer (single-product slides
    // like Mystery Pair, or a color-dot slide with every color already in the cart),
    // and move on to the next slide either way.
    _injectCrossSellSlider(cart, upsellItemMarkup) {
      const { default_cross_sell } = this.selectors;
      const $wrapper = $(default_cross_sell);
      $wrapper.html(upsellItemMarkup);
      const $slider = $wrapper.find(".CrossSell-Slider");
      if (!$slider.length) return;

      const cartVariantIds = cart.items.map((item) => item.variant_id);

      $slider.find(".Carousel__Cell").each((_, el) => {
        const $slide = $(el);
        const $dots = $slide.find(".cs-color-input");
        if ($dots.length) {
          const $checked = $dots.filter(":checked");
          const checkedInCart =
            $checked.length && this._crossSellVariantsInCart($checked.data("variants"), cartVariantIds);

          $dots.each((__, dotEl) => {
            const $dot = $(dotEl);
            if (this._crossSellVariantsInCart($dot.data("variants"), cartVariantIds)) {
              $dot.closest(".ColorDotColumn").remove();
            }
          });

          const $remainingDots = $slide.find(".cs-color-input");
          if (!$remainingDots.length) {
            // Every color on this slide is already in the cart — nothing new to offer.
            $slide.remove();
            return;
          }
          if (checkedInCart) {
            $remainingDots.first().prop("checked", !0).trigger("change");
          }
        } else {
          const variantIds = $slide
            .find('select[name="id"] option')
            .map((_, o) => parseInt(o.value, 10))
            .get();
          if (variantIds.some((id) => cartVariantIds.includes(id))) {
            $slide.remove();
          }
        }
      });

      const $remaining = $slider.find(".Carousel__Cell");
      if (!$remaining.length) {
        $wrapper.empty();
        return;
      }

      const lastIndex = this.lastCrossSellSlideIndex;
      this.lastCrossSellSlideIndex = null;
      let initialIndex = 0;
      if (typeof lastIndex === "number" && !isNaN(lastIndex)) {
        const remaining = $remaining.toArray();
        const nextEl = remaining.find((el) => parseInt($(el).data("slideIndex"), 10) > lastIndex);
        initialIndex = nextEl ? remaining.indexOf(nextEl) : 0;
      }

      new Flickity($slider[0], {
        prevNextButtons: true,
        pageDots: false,
        wrapAround: true,
        adaptiveHeight: true,
        initialIndex,
      });
      refreshMysteryPairSalePrices();
    },
    onCartContentReplacement(event) {
      const {
        cart_banner,
        cart_html,
        cross_sell,
        default_cross_sell,
        option_swatch,
        continue_shopping,
        freeGiftItemAttr,
      } = this.selectors;
      const cart = getCart(event);
      const $continueShopping = $(continue_shopping);
      $continueShopping.toggleClass(
        "hide-all",
        cart.total_price >= 4500 || !cart.items.length
      );
      this._injectDefaultCrossSell(cart);
      MarkdownPricePro.run();
      MarkdownPricePro.calculateCart(cart.items, cart.original_total_price);
      // this.syncLaborDayItems(cart);
      const p = this.currentPromotionObj;
      if (!p || !p.active) return;
      if (
        p.promotionCartBanner &&
        p.promotionCartBanner !== "assets/no-image"
      ) {
        $(cart_banner).attr("src", p.promotionCartBanner);
      }
      if (p.promotionCartHTML) {
        $(cart_html)
          .html(`<p>${p.promotionCartHTML}</p>`)
          .removeClass("hide-all");
      }
      let pIds = p.upsell_item
        ? this.getVariantIds(p?.upsell_item?.variants)
        : [];
      let promoProduct = cart.items.find(
        (i) =>
          pIds.indexOf(i.variant_id) > -1 &&
          i.properties &&
          "_is_promo_item" in i.properties
      );
      this.promoApplied = typeof promoProduct !== "undefined";
      let { others_total_price, others_quantity } = this.cartTotal(cart.items);
      if (
        !this.promoApplied &&
        others_quantity <= p.product_count &&
        !p.add_automatically &&
        others_total_price <= p.order_threshold &&
        !p.upsell_product_in_popup
      ) {
        $(cross_sell).html(p.cross_sell_html);
      }

      let actual_socks_count = 0;
      cart.items.forEach((item) => {
        const productTypeParsed = parseInt(item.product_type.split('-')[0]);
        const productType = isNaN(productTypeParsed) ? (item.product_type === "Starter 5-Pack" ? 5 : 0) : productTypeParsed;
        const itemQuantity = parseInt(item.quantity);
        actual_socks_count += itemQuantity * productType;
      });
      
      if (p.upsell_product_in_popup) {
        if (promoProduct && actual_socks_count < p.individual_sock_count) {
          $(freeGiftItemAttr).remove();
          // return this.removeItem(promoProduct.id);
        }
        this.handleUpsellPopup({
          shippingNotice,
          promo: p,
          others_total_price,
          others_quantity,
          promoProduct,
          event,
          actual_socks_count,
        });
      }

      if (!this.productAdded) return;
      if (
        !this.promoApplied &&
        p.add_automatically &&
        others_quantity >= p.product_count &&
        others_total_price >= p.order_threshold &&
        actual_socks_count >= p.individual_sock_count
      ) {
        this.addUpsellItem(p);
      } else if (
        cart.item_count == 1 ||
        others_quantity < p.product_count ||
        others_total_price < p.order_threshold ||
        actual_socks_count < p.individual_sock_count
      ) {
        // this.removeUpsellItem(p);
      }
    },
    handleUpsellPopup({
      shippingNotice,
      promo,
      othersTotalPrice,
      othersQuantity,
      promoProduct,
      event,
      actual_socks_count,
    }) {      
      const { upsell_modal } = this.selectors;
      const product = event?.originalEvent?.detail?.eventDetails?.product;
      $("#PopupBtn").remove();
      
      if (promo.title === "HHMP" && promo.active) {
        // Remove any existing Heart Health message
        $('.Heart_Health__Container').remove();
        
        let message = '';
        const salePriceSelector = document.getElementById('SideCart-CrossSell-default')?.querySelector('.cross-sell-sale-price');
        const comparePriceSelector = document.getElementById('SideCart-CrossSell-default')?.querySelector('.cross-sell-compare-price');
        if (actual_socks_count === 3) {
          message = `<b>February Only:</b> Add 1 more pair to receive a Free Mystery Pair`;
          salePriceSelector && (salePriceSelector.innerHTML = '$14.99');
          comparePriceSelector && (comparePriceSelector.style.display = 'block');
        } else if (actual_socks_count > 3) {
          // Update the shipping notice text
          shippingNotice.find('.free-shipping-amount-container[data-free-shipping-eligible="true"] p').html(
            'Free Shipping & Free Mystery Pair Unlocked'
          );
          message = 'Share the care, or keep it for yourself!';

          salePriceSelector && (salePriceSelector.innerHTML = 'FREE');
          comparePriceSelector && (comparePriceSelector.style.display = 'none');
        }
        
        // Only add message container if there's a message to show
        if (message) {
          shippingNotice.append(`
            <div class="Heart_Health__Container">
              <p class="Heart_Health__Container-text">${message}</p>
            </div>
          `);
        }
      }

      if (product?.product_type !== "Priority Processing") {
        $(upsell_modal).attr("aria-hidden", !0);
        $(upsell_modal).find(".modalBody").html(promo.cross_sell_html);
      }

      if (
        !promoProduct &&
        product &&
        actual_socks_count >= promo.individual_sock_count
      ) {
        $(upsell_modal).attr("aria-hidden", !1);
      }

      if (promoProduct) {
        $(upsell_modal)
          .find(`input[data-variant-id="${promoProduct.variant_id}"]`)
          .prop("checked", !0);
        $(upsell_modal)
          .find(`select[name="id"] option[value="${promoProduct.variant_id}"]`)
          .prop("selected", !0);
      }
    },
    removeItem: async function (variant_id) {
      const self = this;
      try {
        const response = await fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ updates: { [variant_id]: 0 } }), 
        });
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const cart = await response.json();
        document.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: !0,
            detail: { variant: variant_id, quantity: 1 },
          })
        );
        self.promoApplied = !1;
        return cart;
      } catch (error) {
        console.error("Failed to remove item:", error);
        return !1;
      }
    },
    async addCrossSellItem(e) {
      e.preventDefault();
      const cart = getCart();
      const $button = $(e.currentTarget);
      const type = $button.data("type");
      const crossSellSection = document.getElementById(
        "SideCart-CrossSell-" + type
      );
      const currentVariant = $button
        .closest(".mystery-cart-container, .CrossSell")
        .find('select[name="id"]')
        .val();
      const $slide = $button.closest(".mystery-cart-container, .CrossSell");
      const upsellModule =
        $button.data("upsellModule") ||
        ($slide.closest(".CrossSell-Slider").length ? "slider" : "single");
      const upsellHeading = (
        $button.data("upsellHeading") ||
        $slide.find(".cs-slide-header h2, .cross-sell-banner h2").first().text().trim()
      ).replace(/<[^>]*>/g, "").trim();
      if (upsellModule === "slider") {
        this.lastCrossSellSlideIndex = parseInt($slide.data("slideIndex"), 10);
      }
      $(".Modal__ErrorAlert").remove();
      if (
        type == "promo" &&
        this.currentPromotionObj &&
        this.currentPromotionObj.upsell_item
      ) {
        const selectedUpsellItem = this.currentPromotionObj.upsell_item;
        const upsellItemInCart = cart.items.find(
          (i) => i.product_id == selectedUpsellItem.id
        );
        if (upsellItemInCart) {
          if (upsellItemInCart.variant_id == parseInt(currentVariant)) {
            return $button.before(
              '<p class="Modal__ErrorAlert Alert Alert--error">Please select different size</p>'
            );
          }
          // await this.removeItem(upsellItemInCart.id);
        }
      }
      document.dispatchEvent(new CustomEvent("theme:loading:start"));
      let postData = {
        id: currentVariant,
        quantity: 1,
        properties: {
          _is_promo_item: 1,
          _upsell_item: `${upsellModule}:${upsellHeading}`,
        },
      };
      
      if(this.currentPromotionObj?.active && this.currentPromotionObj?.title) {
        postData.properties._active_promo = `${this.currentPromotionObj?.title?.toLowerCase()}`;
      }
      // Read fresh via .attr() rather than .data() — the slider's color-dot
      // handler updates the attribute directly when the shopper swaps to a
      // different color, and jQuery's .data() cache would still hold the
      // slide's original render-time value.
      if ($slide.attr("data-is-mystery") === "true") {
        applyLineItemPropertyABTests(["mysteryPairAB"], postData.properties);
      }
      fetch("/cart/add.js", {
        body: JSON.stringify(postData),
        credentials: "same-origin",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
      })
        .then((response) => {
          if (response.ok) {
            document.dispatchEvent(new CustomEvent("theme:loading:end"));
            $button.attr("disabled", !1);
            response.json().then((product) => {
              document.dispatchEvent(
                new CustomEvent("product:added", {
                  bubbles: !0,
                  detail: {
                    product,
                    variant: currentVariant,
                    quantity: 1,
                    // Cart-popup promo upsell — not driven by browsing this product's
                    // own collection, so it must never inherit list attribution from
                    // an unrelated earlier click on the same product elsewhere.
                    addSource: "upsell",
                  },
                })
              );
            });
          } else {
            return response.json().then((error) => {
              const errorMessage = document.createElement("span");
              errorMessage.className = "ProductForm__Error Alert Alert--error";
              errorMessage.innerHTML = error.description;
              $button.after(errorMessage);
              setTimeout(() => errorMessage.remove(), 2500);
            });
          }
        })
        .catch((error) => console.error("Error adding item to cart:", error));
    },
    mostFrequent: function (array) {
      let map = array.map((a) => array.filter((b) => a === b).length);
      return array[map.indexOf(Math.max.apply(null, map))];
    },
    getVariantIds: function (variants) {
      return variants.map((v) => v.id);
    },
    setReviewsCookie: function () {
      let show_reviews =
        $.getUrlParameter("show_reviews") || Cookies.get("show_reviews");
      if (show_reviews === "clear") {
        Cookies.set("show_reviews", "clear");
        show_reviews = !1;
      } else if (show_reviews) {
        Cookies.set("show_reviews", show_reviews);
      }
      if (show_reviews && show_reviews !== "clear") {
        $("body").addClass("show-review");
      }
    },
    isValidPromo(promoCode = "") {
      const currentPromotion =
        promoCode || Cookies.get(COOKIE_KEYS.CURRENT_PROMOTION);
      if (!currentPromotion || currentPromotion === "clear") {
        return !1;
      }
      return (
        this.promotionsList[currentPromotion] &&
        this.promotionsList[currentPromotion].active
      );
    },
    setPromoCookies: function (promoCode) {
      if (!this.isValidPromo(promoCode)) {
        Cookies.remove(COOKIE_KEYS.CURRENT_PROMOTION);
        return !1;
      }
      const currentlyAppliedPromo = Cookies.get(COOKIE_KEYS.CURRENT_PROMOTION);
      if (currentlyAppliedPromo && currentlyAppliedPromo === promoCode) {
        return promoCode;
      }
      MarkdownPricePro.clear(COOKIE_KEYS.PROMOTIONAL_MARKDOWN);
      setCookieWithExpiry(
        COOKIE_KEYS.CURRENT_PROMOTION,
        promoCode,
        this.cookieExpiry
      );
      return promoCode;
    },
    setCurrentPromotion: function (primaryCode = "") {
      let promoActive = !1;
      if (!promoActive && this.forcedPromo) {
        promoActive = this.setPromoCookies(this.forcedPromo);
      }
      const couponCode = $.getUrlParameter("cc") || !1;
      if (!promoActive && couponCode == "clear") {
        Cookies.remove(COOKIE_KEYS.PROMOTIONAL_MARKDOWN);
        Cookies.remove(COOKIE_KEYS.CURRENT_PROMOTION);
        MarkdownPricePro.clear(COOKIE_KEYS.PROMOTIONAL_MARKDOWN);
        return;
      }
      if (!promoActive && couponCode) {
        promoActive = this.setPromoCookies(couponCode);
      }
      const storedCode = Cookies.get(COOKIE_KEYS.CURRENT_PROMOTION);
      if (!promoActive && storedCode) {
        promoActive = this.setPromoCookies(storedCode);
      }
      if (!promoActive && primaryCode) {
        promoActive = this.setPromoCookies(primaryCode);
      }
      if (promoActive) {
        this.currentPromotion = promoActive;
        this.currentPromotionObj =
          this.promotionsList[this.currentPromotion] || !1;
        return this.adjustForGoldOnlyPromotions();
      }
      Cookies.remove(COOKIE_KEYS.PROMOTIONAL_MARKDOWN);
      MarkdownPricePro.clear(COOKIE_KEYS.PROMOTIONAL_MARKDOWN);
    },
    adjustForGoldOnlyPromotions() {
      if (this.currentPromotionObj && this.currentPromotionObj.goldOnly) {
        const userStatus = Cookies.get("WW_PR_kStatus");
        if (!userStatus || userStatus !== "GOLD") {
          this.currentPromotion = "clear";
          this.currentPromotionObj = !1;
          setCookieWithExpiry(
            COOKIE_KEYS.CURRENT_PROMOTION,
            this.currentPromotion,
            1
          );
          MarkdownPricePro.clear(COOKIE_KEYS.PROMOTIONAL_MARKDOWN);
        }
      }
    },
    addUpsellItem: function (p) {
      const self = this;
      const properties = { _is_promo_item: 1 };      
      if(this.currentPromotionObj?.active && this.currentPromotionObj?.title) {
        properties._active_promo = `${this.currentPromotionObj?.title?.toLowerCase()}`;
      }
      fetch(globalThis.routes.cartUrl + "/add.js", {
        body: JSON.stringify({
          items: [
            {
              quantity: 1,
              id: p.upsell_item_id,
              properties,
            },
          ],
        }),
        credentials: "same-origin",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
      })
        .then((response) => {
          response.json().then(function (content) {
            self.promoApplied = !0;
          });
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    },
    removeUpsellItem: function (p) {
      const self = this;
      const cart = getCart();
      let pIds =
        "upsell_item" in p ? self.getVariantIds(p.upsell_item?.variants) : [];
      let promo_item = cart.items.find(
        (i) =>
          pIds.indexOf(i.variant_id) > -1 && "_is_promo_item" in i.properties
      );
      if (!promo_item) {
        return;
      }
      return this.removeItem(promo_item.variant_id);
    },
    cartTotal(items) {
      const p = this.currentPromotionObj;
      const pIds = p.upsell_item
        ? this.getVariantIds(p.upsell_item?.variants)
        : [];
      const { others_quantity, others_total_price } = items.reduce(
        (acc, item) => {
          if (
            !pIds.includes(item.variant_id) &&
            !("_is_promo_item" in item.properties) &&
            item.product_type !== "Priority Processing"
          ) {
            acc.others_quantity += item.quantity;
            acc.others_total_price += item.line_price;
          }
          return acc;
        },
        { others_quantity: 0, others_total_price: 0 }
      );
      let total_price =
        Cookies.get("markdown_initialized") === "initialized"
          ? MarkdownPricePro.calculateCart(items) * 100
          : others_total_price;
      return { others_total_price: total_price, others_quantity };
    },
    _getCurrentVariantFromOptions(selected_options, variants) {
      return (
        variants.find(
          (variant) =>
            variant.option1 === selected_options[0] &&
            variant.option2 === selected_options[1] &&
            variant.option3 === selected_options[2]
        ) || null
      );
    },
    applyCustomPromotion() {
      const ps = this.currentPromotionObj;
      if (!ps || !ps.active) return;
      const bodyClass = ps.bodyClass || this.currentPromotion;
      $("body,html").addClass(`${bodyClass} ${this.currentPromotion}`);
      this.applyPromotionStyles(ps);
      this.updateMarkdown(ps);
    },
    applyPromotionStyles(ps) {
      const { announcement, bar, cart_html, cart_form } = this.selectors;
      if (ps.topBarClass) $(announcement).addClass(ps.topBarClass);
      if (ps.top_bg) $(announcement).css("background-color", ps.top_bg);
      if (ps.topBarText) $(bar).html(ps.topBarText);
      if (ps.promotionCartHTML) $(cart_html).html(ps.promotionCartHTML);
      if (ps.discount_code)
        $(cart_form).attr("action", `/cart?discount=${ps.discount_code}`);
    },
    updateMarkdown(ps) {
      if (!ps.enable_markdown) {
        return MarkdownPricePro.clear(COOKIE_KEYS.PROMOTIONAL_MARKDOWN);
      }
      const collections = ps.eligible_collections
        ? ps.eligible_collections.split(",")
        : ps.all_collections.split(",");
      const value = this.calculateDiscountValue(ps.discount_amount);
      const subtract = !ps.discount_amount.includes("%");

      let config = {
        discount_code: ps.discount_code,
        multiplier: value,
        collections,
        subtract,
        id: COOKIE_KEYS.PROMOTIONAL_MARKDOWN,
      };

      if (ps.variants) {
        config.variants = ps.variants.map((v) => {
          return {
            titles: v.titles.split(","),
            multiplier: 1 - v.multiplier / 100,
          };
        });
      }

      MarkdownPricePro.init(config);
    },
    calculateDiscountValue(discount) {
      let value = discount.replace(/[^0-9.]/g, "");
      return discount.includes("%") ? 1 - Number(value) / 100 : Number(value);
    },
    // Labor Day: stamp every cart line eligible for the 25% promo with a hidden
    // `_labor_day: 1` line-item property so the checkout discount rule can target
    // exactly those items. A line is eligible when the active promo is the Labor
    // Day one (LABOURDAY25, markdown enabled) AND the product is in the promo's
    // eligible collections — the same collection check MarkdownPricePro uses.
    // Removes the tag from lines that no longer qualify. Sends `quantity` so the
    // line quantity is preserved, and only writes lines that actually change
    // (idempotent — avoids a change.js feedback loop).
    async syncLaborDayItems(cart) {
      const p = this.currentPromotionObj;
      const isLaborDay =
        p && p.active && p.enable_markdown && p.primaryCode === "LABOURDAY25";
      const eligibleCollections = isLaborDay
        ? (p.eligible_collections || p.all_collections || "")
            .split(",")
            .map((c) => c.trim())
            .filter(Boolean)
        : [];
      const items = (cart && cart.items) || [];
      for (const item of items) {
        const cols = item.product_collections || [];
        const eligible =
          isLaborDay && cols.some((c) => eligibleCollections.includes(c));
        const props = item.properties || {};
        const alreadyTagged = props._labor_day === "1";
        if (eligible === alreadyTagged) continue; // no change needed
        const newProps = Object.assign({}, props);
        if (eligible) {
          newProps._labor_day = "1";
        } else {
          delete newProps._labor_day;
        }
        try {
          await fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              line: item.index + 1,
              quantity: item.quantity,
              properties: newProps,
            }),
          });
        } catch (e) {
          /* ignore individual line failures */
        }
      }
    },
  };
  $.Promotion.defaultOptions = {};

  $.getUrlParameter = function (sParam) {
    let sPageURL = globalThis.location.search.substring(1),
      sURLVariables = sPageURL.split("&"),
      sParameterName,
      i;
    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split("=");
      if (sParameterName[0] === sParam) {
        return typeof sParameterName[1] === undefined
          ? !0
          : decodeURIComponent(sParameterName[1]);
      }
    }
    return !1;
  };

  $.ABTest = {
    init(name, controlPercentage, controlPromoId = "", testPromoId = "") {
      const fraction = controlPercentage / 100;
      if (fraction >= 1 || fraction <= 0) {
        console.error(
          "AB Test control percentage must be greater than 0 and less than 100"
        );
        return;
      }
      Cookies.set("ab_test_fraction", `${fraction}`);
      Cookies.set("ab_test_name", name);
      Cookies.set("ab_test_control_promo", controlPromoId);
      Cookies.set("ab_test_test_promo", testPromoId);
      Cookies.set("ab_test_active", "true");
      setTimeout(() => {
        this.run();
      }, 500);
    },
    run() {
      const fraction = Cookies.get("ab_test_fraction") || "";
      const is_active = Cookies.get("ab_test_active") || "";
      const name = Cookies.get("ab_test_name") || "";
      const control_promo = Cookies.get("ab_test_control_promo") || "";
      const test_promo = Cookies.get("ab_test_test_promo") || "";
      if (!is_active) return;
      let promo;
      if (Math.random() < Number(fraction)) {
        if (control_promo) {
          promo = new $.Promotion(control_promo);
          promo.InitEvents();
        }
      } else {
        if (test_promo) {
          promo = new $.Promotion(test_promo);
          promo.InitEvents();
        }
      }
    },
    clear() {
      Cookies.set("ab_test_fraction", "");
      Cookies.set("ab_test_name", "");
      Cookies.set("ab_test_control_promo", "");
      Cookies.set("ab_test_test_promo", "");
      Cookies.set("ab_test_active", "");
    },
  };
  $.ABTest.run();

  class FrameworksManager {
    constructor() {
      this.promotionalFramework = new $.Promotion();
      this.vanity = globalThis.VanityURL = new VanityURL();
    }
    initVanity(clearList = []) {
      const { AT20_MARKDOWN, PROMOTIONAL_MARKDOWN } = COOKIE_KEYS;
      this.clearMarkdowns(
        clearList.length ? clearList : [AT20_MARKDOWN, PROMOTIONAL_MARKDOWN]
      );
      this.vanity.init();
    }
    initAttentiveMarkdown() {
      MarkdownPricePro.init({
        discount_code: "AT20",
        multiplier: 0.8,
        collections: ["shop-all", "wide-calf-collection"],
        id: COOKIE_KEYS.AT20_MARKDOWN,
      });
    }
    init() {
      const { currentPromotionObj, forcedPromo, currentPromotion } =
        this.promotionalFramework;
      const { VANITY, VANITY_MARKDOWN, AT20_MARKDOWN } = COOKIE_KEYS;
      // Vanity URL framework fully disabled — wipe any stored vanity cookies +
      // markdown on every page load (covers returning visitors) before any of
      // the branch logic below can act on vanity.
      // this.vanity.stop();
      const vu_init = getUrlParam("vu_init");
      const activateVanityFromURL = vu_init === "1";
      const deactivateVanityFromURL = vu_init === "0";
      const activateVanityFromCookie = Cookies.get(VANITY) === "true";

      if (
        currentPromotion !== "PRMD24" &&
        globalThis.themeVariables.template === "collection" &&
        globalThis.location.href.indexOf("collections/mothers-day-exclusive") > -1
      ) {
        globalThis.location.href = "/";
      }

      // Special case for lastchance40
      // if([getUrlParam('vu_cc'),Cookies.get('vu_cc')].includes('LASTCHANCE45')){
      //   return this.initVanity();
      // }

      this.promotionalFramework.InitEvents();
      if (currentPromotionObj && currentPromotionObj.active) {
        if (currentPromotion != "AT20") {
          $("body").addClass("disable-attentive");
        }
        if (activateVanityFromURL) {
          if (currentPromotion != forcedPromo) {
            return this.initVanity();
          }

          // if (currentPromotionObj.enable_markdown) {
          //   const { discount_amount } = currentPromotionObj;
          //   const promotion_discount = parseFloat(discount_amount.replace(/[^0-9.]/g, ""));
          //   const vanity_discount = parseFloat(getUrlParam("vu_dis", 0) || Cookies.get('vu_dis'));
          //   if (vanity_discount > promotion_discount) {
          //     return this.initVanity();
          //   }
          // }
        }

        if (deactivateVanityFromURL) {
          this.clearMarkdowns([VANITY_MARKDOWN]);
          this.vanity.stop();
        }

        if (currentPromotionObj.enable_markdown) {
          let ineligibleList = [AT20_MARKDOWN];
          // If the current vanity is Lastchance40 then keep it along with the current default promotion
          if (
            ![getUrlParam("vu_cc"), Cookies.get("vu_cc")].includes(
              "LASTCHANCE45"
            )
          ) {
            ineligibleList.push(VANITY_MARKDOWN);
          }
          this.clearMarkdowns(ineligibleList);
          if (ineligibleList.includes(VANITY_MARKDOWN)) {
            return this.vanity.stop();
          }

          if (activateVanityFromURL || activateVanityFromCookie) {
            return this.initVanity([AT20_MARKDOWN]);
          }
        }

        // AT20 disabled — clear any active AT20 markdown instead of re-applying it.
        // Original behaviour (kept for reference): re-applied the 0.8 AT20
        // markdown on every page load for users with the AT20 discount_code:
        if (Cookies.get("discount_code") == "AT20") {
          this.initAttentiveMarkdown();
        }
      } else if (activateVanityFromURL || activateVanityFromCookie) {
        this.initVanity();
      } else if (deactivateVanityFromURL) {
        this.clearMarkdowns([VANITY_MARKDOWN]);
        this.vanity.stop();
      }
    }
    clearMarkdowns(ids) {
      ids.forEach((id) => MarkdownPricePro.clear(id));
    }
  }
  new FrameworksManager().init();
})(jQuery);


// ─── Price A/B Test ───────────────────────────────────────────────────────────
// Version A (default, no body class): catalog price shown and charged — no
// discount displayed anywhere.
// Version B (body class 'price-ab-regular' added by Convert Experiences): lower
// "regular" price shown with strikethrough via MarkdownPricePro on PLP/PDP/cart,
// and the Cart Transform Function in wellow-script-editor enforces the same lower
// price at checkout server-side.
//
// Supports multiple rules for different product groups, each with its own fixed
// subtract amount ($ off) and target collections.
//
// Uses MutationObserver because Convert may add the body class asynchronously
// after script execution. Waits up to convertTimeoutMs before resolving.
//
// Configure before enabling:
//   1. Set enabled: true
//   2. Fill in collections arrays with the exact Shopify collection handles
//      (must match the data-product-coll attribute values in the theme markup)
//   3. Create one Cart Transform rule per entry in wellow-script-editor admin:
//      conditions: lineItemProperty _price_ab equals "b" AND collection in [...]
//      discount: fixedAmount matching the subtract value
//   4. Set product catalog prices to the higher (Version A) price in Shopify admin

/** RET = known/retention customer (Personalization); ACQ = acquisition / anonymous */
function getCustomerType() {
  if (document.body.classList.contains("show-retention-banner")) return "RET";
  if (typeof Cookies !== "undefined" && Cookies.get("WW_PR_kStatus")) return "RET";
  if (/(?:^|; )WW_PR_kStatus=/.test(document.cookie)) return "RET";
  return "ACQ";
}

function getPriceAbLineItemProperties() {
  return {
    _price_ab: document.body.classList.contains("price-ab-regular") ? "b" : "a",
    _customer_type: getCustomerType(),
  };
}
globalThis.getPriceAbLineItemProperties = getPriceAbLineItemProperties;
globalThis.getCustomerType = getCustomerType;

class PriceABTest {
  constructor(config = {}) {
    this.enabled = config.enabled || false;
    this.convertTimeoutMs = config.convertTimeoutMs || 2000;
    this.rules = config.rules || [];
    this.resolved = false;
    this.observer = null;
    // When Convert adds the class after the DOM-ready coordinated render,
    // we must re-run markdown ourselves (without a page reload).
    this.rerunAfterApply = false;

    if (!this.enabled) return;

    this.activeRules = this.rules.filter((r) => r.collections.length > 0);

    // Always drop cached price-ab rules first so a stale subtract/multiplier
    // from a previous session cannot win before Version B is confirmed.
    this.clearStoredRules();

    if (!this.activeRules.length) return;

    if (document.body.classList.contains("price-ab-regular")) {
      this.applyVariantBMarkdown();
      return;
    }

    this.rerunAfterApply = true;
    this.observer = new MutationObserver((mutations) => {
      if (this.resolved) return;
      mutations.forEach((mutation) => {
        if (mutation.target.classList.contains("price-ab-regular")) {
          this.resolved = true;
          this.observer.disconnect();
          this.applyVariantBMarkdown();
        }
      });
    });
    this.observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });

    setTimeout(() => {
      if (this.resolved) return;
      this.resolved = true;
      this.observer.disconnect();
      // Version A — keep storage clear; catalog price stands
      this.clearStoredRules();
    }, this.convertTimeoutMs);
  }

  clearStoredRules() {
    this.activeRules.forEach((rule) => {
      MarkdownPricePro.clear(rule.id);
    });
  }

  applyVariantBMarkdown() {
    // Clear then re-register so localStorage always matches the current
    // config subtract values (not a stale cached multiplier).
    this.clearStoredRules();
    this.activeRules.forEach((rule) => {
      MarkdownPricePro.register({
        id: rule.id,
        multiplier: rule.subtract,
        subtract: true,
        collections: rule.collections,
        autoApplyCoupon: false,
        hideStrikethrough: rule.hideStrikethrough || false,
      });
    });

    // Late Convert activation: re-apply markdown in place (no reload).
    // Early activation (class already present at construct): the DOM-ready
    // orchestrator will run right after this constructor returns.
    if (this.rerunAfterApply) {
      MarkdownPricePro.run();
      requestAnimationFrame(() => {
        MarkdownPricePro.run({ overwriteOthers: true, skipSubtract: true });
      });
    }
  }
}

function updateMobileDots() {
  const screenSize = globalThis.innerWidth;
  let dotLength = 6;
  if (screenSize < 481) {
    dotLength = 5;
  }
  setTimeout(function () {
    const productSection = document.querySelector('[data-section-type="product"]');
    const allWraps = document.querySelectorAll(".color-dot-wrap");
    const dotContainers = Array.from(allWraps).filter(
      (wrap) => !productSection || !productSection.contains(wrap)
    );
    dotContainers.forEach((container) => {
      const dotCols = container.querySelectorAll(".color-dot-col");
      dotCols.forEach((el) => (el.style.display = ""));
      const dots = Array.from(dotCols).filter(
        (el) => el.offsetWidth > 0 && el.offsetHeight > 0
      );
      const wrapper = container.closest(".ProductItem__Wrapper, .product-col");
      const firstLink = wrapper ? wrapper.querySelector("a") : null;
      const anchor = firstLink ? firstLink.cloneNode(true) : null;
      const current = container.querySelector("a");
      if (!anchor) return;
      anchor.classList.add("dots-plus");
      if (dots.length > dotLength) {
        const length = dotLength - 1;
        for (let i = length; i < dots.length; i++) {
          dots[i].style.display = "none";
        }
        if (!current) {
          anchor.textContent = `+${dots.length - length}`;
          container.appendChild(anchor);
        } else {
          current.textContent = `+${dots.length - length}`;
        }
      } else {
        if (current) current.remove();
      }
    });
  }, 500);
}

function timeBoundDiscount(percent, code, minutes) {
  let countTime = new Date().getTime();
  let countTimeEnd = countTime + minutes * 60 * 1000;
  Cookies.set("timeBoundTime", countTime);
  Cookies.set("timeBoundTimeEnd", countTimeEnd);
  Cookies.set("timeBoundTimePercent", percent);
  Cookies.set("timeBoundTimeCode", code);
  Cookies.set("timeBoundTimeExpired", 0);
  showTimeBoundOffer();
}

globalThis.showTimeBoundOffer = function () {
  const timerEl = document.getElementById("AttentiveTimer");
  const timeBoundTimeExpired = Cookies.get("timeBoundTimeExpired") || 0;

  if (timeBoundTimeExpired != 0) {
    if (timerEl) timerEl.style.display = "none";
    return;
  }

  const timeBoundTimeEnd = Cookies.get("timeBoundTimeEnd");
  const timeBoundTimePercent = Cookies.get("timeBoundTimePercent");
  const timeBoundTimeCode = Cookies.get("timeBoundTimeCode");

  if (Number(timeBoundTimeEnd) - Number(Date.now()) > 0) {
    const distance = Number(timeBoundTimeEnd) - Number(Date.now());
    let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    let seconds = Math.floor((distance % (1000 * 60)) / 1000);
    if (seconds < 10) {
      seconds = "0" + seconds;
    }

    if (timerEl) {
      const span = timerEl.querySelector("span");
      if (span) {
        span.innerHTML = `<span class="fw-500">You've got ${timeBoundTimePercent}% OFF! use code <strong>${timeBoundTimeCode}</strong> in the next: ${minutes}:${seconds}</span>`;
      }
    }

    if (!document.body.classList.contains("cart") && timerEl) {
      timerEl.style.display = "";
    }

    setTimeout(showTimeBoundOffer, 1000);
  } else {
    Cookies.set("timeBoundTimeExpired", 1);
    if (timerEl) timerEl.style.display = "none";
  }
};

function onDomReady(fn) {
  if (document.readyState !== "loading") {
    fn();
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}

onDomReady(function () {

  function handleYotpoReviewsClick(e) {
    const link = e.target.closest('a[data-product-section="yotpo-reviews"]');
    if (!link) return;
    if (location.pathname.includes("/products/")) {
      e.preventDefault();
    }
  }
  document.addEventListener("click", handleYotpoReviewsClick);
  document.addEventListener("change", handleYotpoReviewsClick);

  function handleYotpoBottomlineClick(e) {
    const link = e.target.closest(".yotpo-bottomline a.text-m");
    if (link && link.parentElement) link.parentElement.click();
  }
  document.addEventListener("click", handleYotpoBottomlineClick);
  document.addEventListener("change", handleYotpoBottomlineClick);

  showTimeBoundOffer();
  // setTimeout(() => MarkdownPricePro.run(), 500);
});

globalThis.attenCallback2 = function (type) {
  const utm_source =
    Cookies.get("__attentive_utm_param_source") ||
    getUrlParam("utm_source", !1);
  const currentPromotion = Cookies.get(COOKIE_KEYS.CURRENT_PROMOTION) || !1;
  const vanityEnabled = Cookies.get(COOKIE_KEYS.VANITY) || !1;
  const invalidCouponCodes = ["clear", "false"];

  if (
    (currentPromotion &&
      currentPromotion.enable_markdown &&
      !invalidCouponCodes.includes(currentPromotion)) ||
    vanityEnabled
  ) {
    return;
  }

  if (type == "email_submit") {
    // if (document.body.classList.contains('at20-markdown-abtest')) {
    //   console.log("control")
    //    autoApplyCouponCode("AT20");
    // } else {

    setCookieWithExpiry(COOKIE_KEYS.CURRENT_PROMOTION, "AT20", 3);
    timeBoundDiscount(20, "AT20", 30);
    MarkdownPricePro.init({
      discount_code: "AT20",
      multiplier: 0.8,
      collections: ["shop-all", "wide-calf-collection"],
      id: COOKIE_KEYS.AT20_MARKDOWN,
    });
    //}

    // }
    try {
      fbq("track", "CompleteRegistration");
    } catch (error) {
      console.log(error);
    }
  }
};


function showText($this) {
  if (
    !$this.hasClass("MainProduct") ||
    globalThis.themeVariables?.template == "product.ankle"
  ) {
    return;
  }
  let size_short = $this.val();
  let product_type = $this.data("product-type");
  let _inch_range = {
    S: "11.5 - 15.5",
    M: "12.5 - 17.5",
    L: "13.5 - 18.5",
    XL: "15 - 19",
    MW: "17 - 21",
    LW: "18 - 22",
    XLW: "18 - 22",
    "M-Wide": "17 - 21",
    "L-Wide": "18 - 22",
    "XL-Wide": "18 - 22",
  };

  let info_text = `<p class="calf-text">Wellow socks fit a wide range of calf sizes. For a size ${size_short} the sweet spot is ${_inch_range[size_short]}”.</p>`;

  if (product_type == "widecalf") {
    _inch_range = {
      ..._inch_range,
      M: "17 - 21",
      L: "18 - 22",
      XL: "18 - 22",
    };
    info_text = `<p class="calf-text">Wellow Wide-Calf socks fit a wide range of calf sizes. For the size ${size_short} the sweet spot is ${_inch_range[size_short]}”. <br><a style="text-decoration:underline;" href="/collections/best-sellers">Click here</a> to shop regular calf sizes.</p>`;
  }

  $(".calf-text").remove();
  $(".no-js.ProductForm__Option").before(info_text);
}

$(function () {
  showText($('.ProductForm__Option [type="radio"]:checked'));
  $(document).on("change", '.ProductForm__Option [type="radio"]', function (e) {
    showText($(this));
  });

  $(document).on("change", 'input[name="privacy-policy"]', (e) => {
    if (e.currentTarget.checked) {
      $(".privacy-policy-error").hide();
      gtag("event", "privacy_policy_event", { title: "Agreed" });
    }
  });

  function addRemovePriorityProcessing(checkbox) {
    document.dispatchEvent(new CustomEvent("theme:loading:start"));

    const isChecked = checkbox.checked;
    const { variantId } = checkbox.dataset;
    const apiUrl = isChecked
      ? globalThis.routes.cartAddUrl
      : globalThis.routes.cartChangeUrl;
    const itemData = { id: variantId, quantity: isChecked ? 1 : 0 };
    const bodyJson = isChecked ? { items: [itemData] } : itemData;
    const allCheckboxes = document.querySelectorAll(
      'input[name="priority-processing"]'
    );

    allCheckboxes.forEach((checkboxInput) => {
      checkboxInput.setAttribute("disabled", "disabled");
      if (checkboxInput !== checkbox) {
        checkboxInput.checked = isChecked;
      }
    });

    fetch(`${apiUrl}.js`, {
      method: "POST",
      credentials: "same-origin",
      body: JSON.stringify(bodyJson),
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    })
      .then(function (response) {
        document.dispatchEvent(new CustomEvent("theme:loading:end"));
        if (response.ok) {
          response.json().then(function (result) {
            checkbox.dispatchEvent(
              new CustomEvent("product:added", {
                bubbles: !0,
                detail: {
                  product: { handle: "priority-processing" },
                  variant: variantId,
                  quantity: 1,
                },
              })
            );
          });
        }
      })
      .catch(function (error) {
        console.error("Error:", error);
      })
      .finally(() => {
        allCheckboxes.forEach((checkboxInput) => {
          checkboxInput.removeAttribute("disabled");
        });
      });
  }

  $(document).on("change", "#PriorityProcessingInput", async (e) => {
    const checkbox = e.currentTarget;
    addRemovePriorityProcessing(checkbox);
  });

  $(document).on("cart:replaceContent", function (e) {
    const cartJson = getCart();
    const giftSleeveItem = cartJson.items.find(
      (i) => i.product_type == "Gift Sleeve"
    );
    const isGoldCustomer = Cookies.get("WW_PR_kStatus") || !1;
    const checkbox = document.getElementById("PriorityProcessingInput");

    // update bundle lineitem property uuid
    const productForm = document.querySelector(".ProductForm");
    if (productForm) {
      const bundleProperty = productForm.querySelector(
        'input[name="properties[_bundle_id]"]'
      );
      if (bundleProperty) {
        const uniqueId = Math.random().toString(36).substr(2, 9);
        bundleProperty.value = uniqueId;
      }
    }

    const $giftSleeveBtns = $(".Gift-Sleeve-ATC-Btn");
    const $disabledGiftSleeveBtns = $giftSleeveBtns.filter(
      '[disabled="disabled"]'
    );
    $giftSleeveBtns.toggleClass("hide-all", !!giftSleeveItem);
    $disabledGiftSleeveBtns.toggleClass("hide-all", !giftSleeveItem);
    $(".ProductForm__AddToCart--Gift-Sleeve")
      .prop("disabled", !!giftSleeveItem)
      .toggleClass("disabled", !!giftSleeveItem);

    if (isGoldCustomer == "GOLD") {
      if (checkbox) {
        checkbox.removeAttribute("checked");
      }
      $(".priority-processing-wrapper").hide();
      return;
    }

    if (!("priority_processing" in THEME_SETTINGS)) {
      return;
    }

    const priorityProcessingItem = cartJson.items.find(
      (i) => i.product_type == "Priority Processing"
    );
    const previousEventDetails = e.detail.eventDetails;
    const priorityProcessingVariantId =
      THEME_SETTINGS.priority_processing.variants[0].id;

    if (
      !previousEventDetails ||
      !("variant" in previousEventDetails) ||
      priorityProcessingVariantId == previousEventDetails.variant
    ) {
      return;
    }

    if (checkbox && checkbox.checked && priorityProcessingItem) return;
    if (checkbox && !priorityProcessingItem) {
      if (
        isGoldCustomer == "GOLD" ||
        !$("body").hasClass("priority-processing")
      ) {
        checkbox.removeAttribute("checked");
      } else {
        checkbox.setAttribute("checked", "checked");
      }
      addRemovePriorityProcessing(checkbox);
    }
  });

  // $(document).on("click", 'button[name="checkout"]', (e) => {
  //   e.preventDefault();
  //   const form = $(e.currentTarget).parents("form");
  //   if (!$(".privacy-policy-checkbox:visible").length) {
  //     form.submit();
  //     return;
  //   }

  //   const error_message = $(".privacy-policy-error");
  //   const checked = $('input[name="privacy-policy"]').is(":checked");
  //   if (!checked) {
  //     gtag("event", "privacy_policy_event", { title: "Error" });
  //     return error_message.show();
  //   }
  //   form.submit();
  // });
});

/**
 * Personalisation JS
 */
function getUrlVars() {
  var vars = {};
  var parts = globalThis.location.href.replace(
    /[?&]+([^=&]+)=([^&]*)/gi,
    function (m, key, value) {
      vars[key] = value;
    }
  );
  return vars;
}

function getUrlParam(parameter, defaultvalue = !1) {
  var urlparameter = defaultvalue;
  if (globalThis.location.href.indexOf(parameter) > -1) {
    urlparameter = getUrlVars()[parameter];
  }
  return urlparameter;
}

class Personalization {
  constructor() {
    this.APP_URL = "/apps/gold-program";
    this.ORDERS_THRESHOLD = 2;
    this.SHOP = Shopify.shop;
    this.GOLD_USER_CLASS = "gold-member-active";
    this.GOLD_USER = "GOLD";
    this.ALMOST_GOLD = "ALMOST_GOLD";
    this.NON_PURCHASER = "NON_PURCHASER";
    this.TOTAL_SPENT_LIMIT = 120;
    this.CUSTOM_ACCOUNT_SECTION = "main-customers-account-custom";
    this.COOKIES_EXPIRY_DAYS = 30;
    this.SELECTORS = {
      goldStatusBtn: "#GoldStatusBtn",
      statusModal: ".custom-model-main",
      checkGoldMember: ".checkGoldMember",
      goldStatusEmailField: "#GoldStatusEmailField",
      statusForm: "#StatusForm",
      statusSuccess: "#StatusSuccess",
      statusFailed: "#StatusFailed",
      goldEligiblity: "#goldEligiblity",
      pdpCheckStatus: ".gold-member-check-block",
      main: "main#main",
      pageLoader: ".Page__Preloader",
    };
    this.LANG = {
      validEmailMessage: `Please enter valid email address.`,
      cannotBeEmpty: `Email field cannot be empty.`,
      noPurchase: `<ul>
                  <li>Make <b>at least two purchases</b> with Wellow</li>
                  <li>Have made at least <b>one purchase</b> in the last 12 months*</li>
                </ul>`,
      almostGold: `<ul>
				<li>Make <b>at least two purchases</b> with Wellow</li>
                  <li>Have made at least <b>one purchase</b> in the last 12 months*</li>
                </ul>`,
    };
  }
  init() {
    this.initEvents();
    const customer_status = this.checkPersonalizationObject();
    if (!customer_status) {
      this.getKlaviyoIdFromUrl();
      this.trackPersonalization();
    }
  }

  initEvents() {
    const {
      goldStatusBtn,
      statusModal,
      checkGoldMember,
      goldStatusEmailField,
      statusForm,
      statusSuccess,
      statusFailed,
    } = this.SELECTORS;
    $(checkGoldMember).on("click", function () {
      $(goldStatusEmailField).val("");
      $(statusForm).show();
      $(statusSuccess).hide();
      $(statusFailed).hide();
      $(statusModal).addClass("model-open");
    });
    $(".close-btn, .bg-overlay").click(function () {
      $(statusModal).removeClass("model-open");
    });
    $(goldStatusBtn).on("click", this.checkCustomerStatus.bind(this));
    $(goldStatusEmailField).on("input change", this.removeError.bind(this));
  }
  removeError() {
    const { goldStatusEmailField } = this.SELECTORS;
    $(goldStatusEmailField)
      .removeClass("error")
      .next(".error-message")
      .remove();
  }
  checkCustomerStatus() {
    const {
      goldStatusEmailField,
      statusForm,
      statusSuccess,
      statusFailed,
      goldEligiblity,
    } = this.SELECTORS;
    const { noPurchase, almostGold, validEmailMessage, cannotBeEmpty } =
      this.LANG;
    const customerEmail = $(goldStatusEmailField).val();
    $(".error-message").remove();
    $(goldStatusEmailField).removeClass("error");
    if (!customerEmail) {
      return $(goldStatusEmailField)
        .addClass("error")
        .after(`<p class="error-message">${cannotBeEmpty}</p>`);
    }
    let inputUrl = new URL(
      location.origin + this.APP_URL + "/api/customer/status"
    );
    inputUrl.searchParams.append("customer_email", customerEmail);
    $.ajax({
      url: inputUrl,
      dataType: "json",
      type: "get",
      success: function (e) {
        $(".error-message").remove();
        if (!e) return;
        if (e.success) {
          const data = e.data;
          if (data.is_gold_user) {
            $(statusForm).hide();
            $(statusSuccess).show();
          } else {
            $(statusForm).hide();
            $(statusFailed)
              .show()
              .find(goldEligiblity)
              .html(data.orders_count == 0 ? noPurchase : almostGold);
          }
        } else {
          $(statusForm).hide();
          $(statusFailed).show().find(goldEligiblity).html(noPurchase);
        }
      },
    }).fail(function (e) {
      $(".error-message").remove();
      const json = e.responseJSON;
      $(goldStatusEmailField)
        .addClass("error")
        .after(`<p class="error-message">${validEmailMessage}</p>`);
    });
  }
  customerStatus(customer) {
    if (this.isEmpty(customer)) return;
    const goldTag = this.GOLD_USER;
    let tags = customer.tags;
    if (!tags && "Shopify Tags" in customer) {
      tags = customer["Shopify Tags"];
    }
    if ("gold_user" in customer && customer.gold_user) {
      return goldTag;
    }
    if (tags && tags.indexOf(goldTag) !== -1) {
      return goldTag;
    } else if (
      "orders_count" in customer &&
      customer.orders_count > 0 &&
      customer.orders_count < this.ORDERS_THRESHOLD &&
      customer.total_spent >= this.TOTAL_SPENT_LIMIT
    ) {
      return this.ALMOST_GOLD;
    } else {
      return this.NON_PURCHASER;
    }
  }
  getKlaviyoUserInfo(id) {
    const self = this;
    return new Promise((resolve, reject) => {
      if (!id) return reject("No ID supplied");
      return $.getJSON(
        `${self.APP_URL}/api/klaviyo/profile/${id}`,
        function (data) {
          if (!data || !data.id) return reject("No data");
          const profile = data.attributes;
          const customer_status = self.customerStatus(profile.properties);
          const id = data.id;
          const email = profile.email;
          Cookies.set("WW_PR_kStatus", customer_status, {
            expires: self.COOKIES_EXPIRY_DAYS,
          });
          Cookies.set("WW_PR_kId", id, { expires: self.COOKIES_EXPIRY_DAYS });
          Cookies.set("WW_PR_kEm", email, {
            expires: self.COOKIES_EXPIRY_DAYS,
          });
          Cookies.set("WW_PR_LastSaved", new Date(), {
            expires: self.COOKIES_EXPIRY_DAYS,
          });
          if (!customer_status || !id) return reject("No ID or Status");
          self.track({ id, customer_status });
          self.checkPersonalizationObject();
          return resolve(data);
        }
      );
    });
  }
  gaTrack(label, id, data) {
    const self = this;
    try {
      ga(function (tracker) {
        if (!tracker) {
          return setTimeout(() => {
            self.gaTrack(data);
          }, 500);
        }
        ga("send", "event", label, id, data);
      });
    } catch (error) {
      setTimeout(() => {
        self.gaTrack(data);
      }, 1000);
    }
  }
  track(data) {
    this.gaTrack("Personalization", data.id, data.gold_user);
  }
  sendTracking(id, gold_user) {
    const self = this;
    try {
      ga(function (tracker) {
        if (!tracker) {
          return setTimeout(() => {
            self.sendTracking(id, gold_user);
          }, 500);
        }
        ga("send", "event", "Personalization-tracked", id, gold_user);
        const now = Date.now();
        Cookies.set("WW_PR_pTracked", `${now}`, {
          expires: self.COOKIES_EXPIRY_DAYS,
        });
      });
    } catch (error) {
      setTimeout(() => {
        self.sendTracking(id, gold_user);
      }, 1000);
    }
  }
  getKlaviyoInfoFromEmail(email) {
    if (!email) return;
    const self = this;
    let inputUrl = new URL(
      location.origin + this.APP_URL + "/api/klaviyo/profile-email"
    );
    inputUrl.searchParams.append("email", email);
    $.getJSON(inputUrl).done(function (data) {
      if (!data || !data.id) return console.warning("No data");
      const id = data.id;
      const profile = data.attributes;
      const email = profile.email;
      const customer_status = self.customerStatus(profile.properties);
      Cookies.set("WW_PR_kStatus", customer_status, {
        expires: self.COOKIES_EXPIRY_DAYS,
      });
      Cookies.set("WW_PR_kId", id, { expires: self.COOKIES_EXPIRY_DAYS });
      Cookies.set("WW_PR_kEm", email, { expires: self.COOKIES_EXPIRY_DAYS });
      Cookies.set("WW_PR_LastSaved", new Date(), { expires: 30 });
      if (!customer_status || !id) return console.warning("No ID or Status");
      self.checkPersonalizationObject();
    });
  }
  getKlaviyoIdFromUrl() {
    let bxid = getUrlParam("bxid");
    if (!bxid) return;
    Cookies.set("WW_PR_klaviyo_id", bxid, {
      expires: this.COOKIES_EXPIRY_DAYS,
    });
    this.checkPersonalizationObject();
  }
  trackPersonalization() {
    const gold_user = Cookies.get("WW_PR_kStatus");
    const personalization_tracked = Number(Cookies.get("WW_PR_pTracked")) || 0;
    const klaviyo_id = Cookies.get("WW_PR_kId");
    const now = Date.now();
    const sixHours = 21600000;
    if (gold_user && now - personalization_tracked >= sixHours) {
      this.sendTracking(klaviyo_id, gold_user);
    }
  }
  checkPersonalizationObject() {
    if (!this.isEmpty(customer)) {
      const email = customer.email;
      const customer_status = this.customerStatus(customer);
      Cookies.set("WW_PR_kStatus", customer_status, {
        expires: this.COOKIES_EXPIRY_DAYS,
      });
      Cookies.set("WW_PR_kEm", email, { expires: this.COOKIES_EXPIRY_DAYS });
      Cookies.set("WW_PR_klaviyo_em", email, {
        expires: this.COOKIES_EXPIRY_DAYS,
      });
      return this.personalizeExperience({ email, customer_status });
    }
    const customer_status = Cookies.get("WW_PR_kStatus");
    const klaviyo_id = Cookies.get("WW_PR_kId");
    const last_saved_time = Cookies.get("WW_PR_LastSaved") || !1;
    if (last_saved_time && customer_status && klaviyo_id) {
      const currentTime = new Date();
      const lastSavedTime = new Date(last_saved_time);
      const hours = Math.abs(currentTime - lastSavedTime) / 36e5;
      if (hours > 24) {
        return this.getKlaviyoUserInfo(klaviyo_id);
      }
    }
    if (!customer_status || !klaviyo_id) {
      const id = Cookies.get("WW_PR_klaviyo_id");
      if (!id) {
        const email = Cookies.get("WW_PR_klaviyo_em");
        if (!email) {
          return;
        }
        return this.getKlaviyoInfoFromEmail(email);
      }
      return this.getKlaviyoUserInfo(id);
    }
    const url_id = Cookies.get("WW_PR_klaviyo_id");
    if (url_id && url_id !== klaviyo_id) {
      this.getKlaviyoUserInfo(url_id);
    }
    const email = Cookies.get("WW_PR_kEm");    
    return this.personalizeExperience({ email, customer_status });
  }
  personalizeExperience(object) {
    if (!object) return;
    const { email, customer_status } = object;
    const { pdpCheckStatus, main, pageLoader } = this.SELECTORS;
    if (customer_status == this.ALMOST_GOLD) {
      $(pdpCheckStatus).show();
    }

    document.body.classList.add("show-retention-banner");
    
    if (customer_status != this.GOLD_USER) {
      $(pageLoader).hide();
      return $(main).removeClass("visually-hidden");
    }
    $(".priority-processing-wrapper").hide();
    $(".priority-processing-wrapper input[name='priority-processing']").prop(
      "checked",
      !1
    );
    $("body").addClass(this.GOLD_USER_CLASS);
    if ($("body").hasClass("template-account")) {
      fetch(
        globalThis.Shopify.routes.root + `?sections=${this.CUSTOM_ACCOUNT_SECTION}`
      )
        .then((res) => res.json())
        .then((data) => {
          $(pageLoader).hide();
          $(main)
            .html(data[this.CUSTOM_ACCOUNT_SECTION])
            .removeClass("visually-hidden");
        });
    }
    
  }
  checkAttentiveSignup() {
    if ($(window).width() > 480) return;
    const self = this;
    const id = Cookies.get("WW_PR_kId");
    const attentiveShown = Cookies.get("WW_PR_asShown");
    if (!id || attentiveShown) return;
    this.getKlaviyoUserInfo(id).then((data) => {
      if (!data) return;
      if (data.sms_attentive_signup) {
        Cookies.remove("WW_PR_asTrigger");
        Cookies.set("WW_PR_asSms", data.sms_attentive_signup, {
          expires: self.COOKIES_EXPIRY_DAYS,
        });
      } else {
        Cookies.set("WW_PR_asTrigger", !0, {
          expires: self.COOKIES_EXPIRY_DAYS,
        });
      }
      self.triggerAttentiveSignup();
    });
  }
  triggerAttentiveSignup() {
    const id = Cookies.get("WW_PR_kId");
    const email = Cookies.get("WW_PR_kEm");
    const trigger = Cookies.get("WW_PR_asTrigger");
    const attentiveShown = Cookies.get("WW_PR_asShown");
    if (attentiveShown || !trigger) return;
    this.triggerAttentive(id, email);
  }
  triggerAttentive(id, email) {
    try {
      if (!globalThis.__attentive?.trigger) {
        return setTimeout(() => {
          this.triggerAttentive(id, email);
        }, 500);
      }
      globalThis.__attentive.trigger(null, id, email, 269269);
      Cookies.set("WW_PR_asShown", !0, { expires: 7 });
      this.gaTrack("Attentive-Signup", id, "Attentive signup triggered");
    } catch (error) {
      setTimeout(() => {
        this.triggerAttentive(id, email);
      }, 1000);
    }
  }
  isEmpty(Obj) {
    return Object.keys(Obj).length === 0 && Obj.constructor === Object;
  }
}

/* ─── Line-item property A/B tests ──────────────────────────────────────────
   Generic framework tying an add-to-cart line item property to a body class:
   register a test with the body class to watch and the property to stamp,
   then apply it to any add-to-cart payload for the item(s) under test.
   The body class is checked on load AND on every mutation, since an external
   A/B tool (Convert, GA Optimize, etc.) can add it well after page load —
   a one-time read at construction time would miss a late-arriving variant. */
class LineItemPropertyABTest {
  constructor({ bodyClass, propertyKey, propertyValue = "1", onChange }) {
    this.bodyClass = bodyClass;
    this.propertyKey = propertyKey;
    this.propertyValue = propertyValue;
    this.onChange = onChange;
    this.isActive = document.body.classList.contains(bodyClass);
    this._observeBodyClass();
  }

  _observeBodyClass() {
    const observer = new MutationObserver(() => {
      const isActive = document.body.classList.contains(this.bodyClass);
      if (isActive === this.isActive) return;
      this.isActive = isActive;
      this.onChange?.(this.isActive);
    });
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });
  }

  // Mutates `properties` in place and returns it, only when the test is
  // currently active — a no-op otherwise, so callers can apply unconditionally.
  applyTo(properties) {
    if (this.isActive) {
      properties[this.propertyKey] = this.propertyValue;
    }
    return properties;
  }
}

// Registry so any add-to-cart flow can look up and apply a test by name
// without importing/instantiating it directly.
window.lineItemPropertyABTests = window.lineItemPropertyABTests || {};

function registerLineItemPropertyABTest(name, config) {
  window.lineItemPropertyABTests[name] = new LineItemPropertyABTest(config);
  return window.lineItemPropertyABTests[name];
}

function applyLineItemPropertyABTests(names, properties) {
  names.forEach((name) => {
    window.lineItemPropertyABTests[name]?.applyTo(properties);
  });
  return properties;
}

// Mystery Pair A/B — cart-drawer sale price display.
// Reduces .cross-sell-sale-price by $2 off the original data-price while
// mystery-pair-ab is active, and restores the original price if the class
// is removed. Scoped to #sidebar-cart so it can never touch a same-named
// element outside the cart drawer's cross-sell/upsell module.
function refreshMysteryPairSalePrices() {
  const isActive = document.body.classList.contains("mystery-pair-ab");
  document
    .querySelectorAll("#sidebar-cart .cross-sell-sale-price[data-price]")
    .forEach((el) => {
      const original = parseInt(el.dataset.price, 10);
      if (Number.isNaN(original)) return;
      const cents = isActive ? Math.max(original - 200, 0) : original;
      const dollars = (cents / 100).toFixed(2);
      el.textContent = "$" + (dollars.endsWith(".00") ? dollars.slice(0, -3) : dollars);
    });
}

class LastchanceCollection {
  constructor(invalidList = []) {
    this.markdownObject = localStorageUtils.get("markdown_object") || [];
    this.markdownId = "last-chance-collection35";
    this.invalidList = invalidList;
    const defaultList = [
      "july-4th-sale",
      "last-chance-collection40",
      "last-chance-collection45",
      "last-chance-collection55",
      "last-chance-collection",
      "last-chance-collection50",
      // Retired flat-rate id, superseded by the tiered ids above.
      "last-chance-collection25",
      "last-chance-collection30"
    ];

    this.invalidList = defaultList.concat(this.invalidList);

    this.isLastchanceCollection =
      (globalThis.location.href.includes("/collections/last-chance-collection") || globalThis.location.href.includes("/collections/july-4th-sale")) &&
      globalThis.theme.pageType == "collection";

    this.clearExistingMarkdown();

    this.applyMarkdown();

    // const observer = new MutationObserver((mutations) => {
    //   for (const { target } of mutations) {
    //     const { classList } = target;
    //     if (classList.contains('lastchance-with-markdown') || classList.contains('lastchance-no-markdown')) {
    //       observer.disconnect();
    //       if (classList.contains('lastchance-with-markdown')) {
    //         this.applyMarkdown();
    //       } else {
    //         MarkdownPricePro.clear(this.markdownId);
    //       }
    //       break;
    //     }
    //   }
    // });
    // observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    // this.changeTopbarMessage()
  }

  clearExistingMarkdown() {
    const self = this;
    const currentIds = [this.markdownId];
    this.markdownObject.forEach((markdown) => {
      if (
        (markdown.markdown_id.includes("last-chance-collection") || self.invalidList.includes(markdown.markdown_id)) &&
        !currentIds.includes(markdown.markdown_id)
      ) {
        MarkdownPricePro.clear(markdown.markdown_id);
      }
    });
  }

  applyMarkdown() {
    // register() writes to localStorage without triggering a run. The
    // DOM-ready block issues a single coordinated render after all markdowns
    // (both subtract and multiply) are registered, avoiding the race where
    // an early run() replaces span.Price nodes before the multiply markdown
    // has a chance to query them.
    MarkdownPricePro.register({
      discount_code: "LASTCHANCE35",
      multiplier: 0.65,
      collections: ["last-chance-collection", "last-chance-sale"],
      id: this.markdownId,
      autoApplyCoupon: false,
      expires: 3,
    });
  }

  changeTopbarMessage() {
    const markdownId = this.markdownId;
    const existing = this.markdownObject.find(
      (m) => m.markdown_id === markdownId
    );
    let showTopBarCopy = false;
    if (this.isLastchanceCollection) {
      showTopBarCopy = true;
      setCookieWithExpiry("change_top_bar_copy", true, 3);
    }

    const changeTopBarCopy = Cookies.get("change_top_bar_copy") || false;
    if (showTopBarCopy || (existing && changeTopBarCopy)) {
      $(".AnnouncementBar__Content").html(
        `<b><a href='/collections/last-chance-collection'> SPECIAL OFFER : 35% OFF ON Last Chance Collection</a></b>`
      );
    }
  }
}

class AB_Test {
  constructor(options = {}) {
    try {
      this.initializeTest();
    } catch (error) {
      console.warning("Homepage AB test failed to run");
    }
  }

  initializeTest() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.target.classList.contains("home-hero-ab")) {
          // Recalculate Flickity dimensions
          const sliderElement = document.querySelector(
            'section[data-section-type="slideshow"].b-slide .Slideshow__Carousel'
          );
          const flickityInstance = Flickity.data(sliderElement);
          if (flickityInstance) {
            flickityInstance.resize();
          }
        }
      });
    });

    // Observe changes on the body element
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });
  }
}

$(function () {
  new Personalization().init();

  ['price-ab-ankle-midcalf', 'last-chance-collection25', 'last-chance-collection30'].forEach(id => {
    MarkdownPricePro.clear(id);
  });

  // Register all markdowns — no run() fires during registration.
  new PriceABTest({
    enabled: true,
    convertTimeoutMs: 2000,
    rules: [
      {
        id: 'price-ab-knee-high',
        subtract: 2,
        collections: ['knee-highs'],
        hideStrikethrough: true,
      },
    ],
  });
  new LastchanceCollection();

  registerLineItemPropertyABTest("mysteryPairAB", {
    bodyClass: "mystery-pair-ab",
    propertyKey: "_mystery_ab",
    propertyValue: "1",
    onChange: refreshMysteryPairSalePrices,
  });
  // Covers the case where the cross-sell markup is already in the DOM
  // (cart drawer opened before the class arrived) when the body class changes.
  refreshMysteryPairSalePrices();

  // Single coordinated render after all markdowns are in localStorage.
  // Pass 1 (synchronous scheduling): plain run() processes all span.Price
  // elements. The sort inside run() ensures subtract markdowns go first,
  // so subtract replaces span.Price → [data-target="price-element"] and
  // the multiply markdown's domUpdate for the same node is queued second.
  // Because both updates target the same live DOM node and are batched into
  // the same rAF, only the first (subtract) write takes effect — the second
  // (multiply) targets an already-detached node and is a no-op.
  // Pass 2 (next rAF): run with overwriteOthers+skipSubtract re-queries
  // [data-target="price-element"] nodes written by Pass 1 and applies the
  // multiply (july-4th-sale) on top. This is the only correct way to stack
  // subtract + multiply without DOM-race conditions.
  MarkdownPricePro.run();
  requestAnimationFrame(() => {
    MarkdownPricePro.run({ overwriteOthers: true, skipSubtract: true });
  });

  // new AB_Test();
});

class UpsellGridItem extends HTMLElement {
  constructor() {
    super();
    this.variantOptionAliases = {
      S: "Small",
      M: "Medium",
      L: "Large",
      XL: "Extra Large",
      "M-Wide": "Wide-Calf Medium",
      "L-Wide": "Wide-Calf Large",
      "XL-Wide": "Wide-Calf Extra Large",
    };
  }

  connectedCallback() {
    const colorDots = this.querySelectorAll(".ColorDotColumn input");
    colorDots.forEach((dot) => {
      dot.addEventListener("change", this.handleColorDotChange.bind(this));
    });

    this.addToCartButton = this.querySelector(".ProductItem__AddToCart button");
    this.addToCartButton.addEventListener(
      "click",
      this.handleAddToCart.bind(this)
    );
  }

  handleColorDotChange(event) {
    try {
      const self = this;
      const colorInput = event.target;
      const productId = colorInput.dataset.productId;
      const swatchJsonContent = this.querySelector(
        `#UpsellGridItem-SwatchJson-${productId}`
      ).innerHTML;
      const swatchJson = JSON.parse(swatchJsonContent);
      if (!swatchJson) {
        return;
      }

      const productPrice = colorInput.dataset.productPrice;
      const productComparePrice = colorInput.dataset.productComparePrice;
      const productCollections = colorInput.dataset.productCollections;
      var imageWrapper = this.querySelector(".ProductItem__ImageWrapper");
      var imageEl = imageWrapper.querySelector(".AspectRatio img");
      var titleEl = this.querySelector(".ProductItem__Title a");
      var selectEl = this.querySelector('select[title="UpsellProductVariant"]');
      var priceEl = this.querySelector(".ProductItem__PriceList");
      var productUrl = `/products/${swatchJson.handle}`;
      var productTags = swatchJson.tags;
      
      titleEl.setAttribute("href", productUrl);
      titleEl.querySelector("span.fs-11").innerHTML = swatchJson.title.includes(
        " - "
      )
        ? swatchJson.title.split(" - ")[0]
        : swatchJson.title;

      priceEl.setAttribute("data-price", productPrice);
      priceEl.setAttribute("data-compare-price", productComparePrice);
      priceEl.setAttribute("data-product-coll", productCollections);
      priceEl.setAttribute("data-pack-size", 1);

      priceEl.innerHTML = `<span class="ProductItem__Price Price Text--subdued DefaultPrice current-price">$${(
        swatchJson.price / 100
      ).toFixed(2)}</span>`;

      swatchJson.variants.forEach(function (variant) {
        var option = selectEl.querySelector(
          `option[data-title="${variant.title}"]`
        );
        var variantTitle = self.variantOptionAliases[variant.title]
          ? self.variantOptionAliases[variant.title]
          : variant.title;
        option.removeAttribute("selected");
        if (!variant.available) {
          option.setAttribute("disabled", "disabled");
        } else {
          option.removeAttribute("disabled");
        }
        option.value = variant.id;
        option.dataset.sku = variant.sku;
        option.dataset.title = variant.title;
        option.innerHTML = `${variantTitle}`;
      });

      selectEl
        .querySelector("option:not(:disabled)")
        .setAttribute("selected", "selected");

      const featuredImage = new URL(`https:/${swatchJson.featured_image}`);
      const widths = imageEl
        .getAttribute("data-media-widths")
        .replace(/\[|\]/g, "")
        .split(",");

      const srcset = widths
        .map(function (width) {
          featuredImage.searchParams.set("width", width);
          return `${featuredImage.href} ${width}w`;
        })
        .join(", ");

      imageEl.setAttribute("src", featuredImage.href);
      imageEl.setAttribute("srcset", srcset);
      imageEl.alt = `${swatchJson.title} image`;
      imageWrapper.setAttribute("href", productUrl);

      document.dispatchEvent(
        new CustomEvent("color-dot:changed", {
          bubbles: true,
          cancelable: true,
          detail: {
            newDot: swatchJson,
          },
        })
      );
      // color-dot:changed event above is handled by MultiTierPromotionalFramework
      // which issues the two-pass render. No direct run() needed here.
    } catch (error) {
      console.log(error);
    }
  }

  handleAddToCart(event) {
    try {
      const self = this;
      const addToCartButton = this.addToCartButton;
      const selectEl = this.querySelector(
        'select[title="UpsellProductVariant"]'
      );
      const selectedVariant = selectEl.options[selectEl.selectedIndex];
      const variantId = selectedVariant.value;
      const quantity = 1;
      const isNoShowUpsell = !!this.closest('.upsell-item-wrapper--pdp-ab-b');

      // Position of the currently-selected colorway among this widget's own color
      // dots (1-based, matching the collection-grid slotIndex() convention) — this
      // is "index" for GA4 purposes, distinct from the host PDP's own list position.
      const colorDots = Array.from(
        this.querySelectorAll(".ColorDotGroup--PDP-Upsell input")
      );
      const selectedDotIndex = colorDots.findIndex((dot) => dot.checked) + 1;
      const currentProductHandle = this.dataset.currentProductHandle;
      const currentProductTitle = this.dataset.currentProductTitle;

      const properties = {
        _product_collections: this.dataset.productColl,
        ...getPriceAbLineItemProperties(),
      };

      if (isNoShowUpsell) {
        properties._no_show = 1;
      } else {
        properties._ankle_upsell = 1;
      }

      const itemData = { id: variantId, quantity, properties };
      const bodyJson = { items: [itemData] };

      addToCartButton.setAttribute("disabled", "disabled");
      addToCartButton.classList.add("is-loading");
      document.dispatchEvent(new CustomEvent("theme:loading:start"));

      fetch(`${globalThis.routes.cartAddUrl}.js`, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify(bodyJson),
      })
        .then(function (response) {
          document.dispatchEvent(new CustomEvent("theme:loading:end"));
          if (response.ok) {
            addToCartButton.classList.remove("is-loading");
            addToCartButton.removeAttribute("disabled");
            response.json().then(function (result) {
              const item = result?.items[0];
              addToCartButton.dispatchEvent(
                new CustomEvent("product:added", {
                  bubbles: !0,
                  detail: {
                    product: item,
                    variant: variantId,
                    quantity: 1,
                    // PDP-embedded upsell — not driven by browsing this product's own
                    // collection, so it must never inherit list attribution from an
                    // unrelated earlier click on the same product elsewhere. Instead,
                    // attribute it to the host PDP it was surfaced on.
                    addSource: "upsell",
                    listId: currentProductHandle,
                    listName: currentProductTitle,
                    listIndex: selectedDotIndex > 0 ? selectedDotIndex : undefined,
                  },
                })
              );

              gtag("event", "ankle_upsell_add_to_cart", {
                value: item.line_price / 100,
                currency: globalThis.themeVariables?.cart?.currency || "USD",
                items: [
                  {
                    properties: item.properties,
                    quantity: item.quantity,
                    variant_id: item.variant_id,
                    product_title: item.product_title,
                    variant_title: item.variant_title,
                    price: item.price / 100,
                    original_price: item.original_price / 100,
                    sku: item.sku,
                    product_id: item.product_id,
                  },
                ],
              });
            });
          } else {
            addToCartButton.classList.remove("is-loading");
            addToCartButton.removeAttribute("disabled");
          }
        })
        .catch(function (error) {
          console.error("Error:", error);
          addToCartButton.classList.remove("is-loading");
          addToCartButton.removeAttribute("disabled");
        });
    } catch (error) {
      console.log(error);
    }
  }

  disconnectedCallback() {
    const colorDots = this.querySelectorAll(".ColorDotColumn input");
    colorDots.forEach((dot) => {
      dot.removeEventListener("change", this.handleColorDotChange.bind(this));
    });
  }
}
customElements.define("upsell-product-item", UpsellGridItem);

class ABTest {
  constructor() {
    this.init();
  }
  init() {
    this.checkAndUpdate();

    const abTestCookie = Cookies.get("site_preview");
    if (abTestCookie) {
      document.body.classList.add(`${abTestCookie}-ab-test`);
    }
  }

  checkAndUpdate() {
    const parameter = getUrlParam("site_preview");

    if (parameter) {
      if (parameter == "clear" || parameter == "false") {
        Cookies.remove("site_preview");
        return;
      }

      setCookieWithExpiry("site_preview", parameter, 3);
    }
  }
}

/* ─── Autoplay video play/pause overlay ────────────────────────────────── */
function syncVideoBtn(btn, video) {
  if (video.paused) {
    btn.classList.add("is-paused");
    btn.setAttribute("aria-label", "Play video");
  } else {
    btn.classList.remove("is-paused");
    btn.setAttribute("aria-label", "Pause video");
  }
}

// Sync every play/pause button currently in the DOM to its video's state.
function syncAllVideoBtns() {
  document.querySelectorAll("[data-video-ctrl]").forEach(function (btn) {
    var wrapper = btn.closest(".autoplay-video-wrapper");
    if (!wrapper) return;
    var video = wrapper.querySelector("video");
    if (video) syncVideoBtn(btn, video);
  });
}

function initVideoPlayPause() {
  // Use document-level delegation so the controls keep working after the DOM
  // is re-rendered — e.g. the fabric-upgrade switch swaps the multi-column-card
  // section in place, which would strip per-element listeners from the new
  // nodes. Attach the delegated listeners only once.
  if (!window.__videoCtrlDelegatedBound) {
    window.__videoCtrlDelegatedBound = true;

    // Click → toggle the video inside the clicked control's wrapper.
    document.addEventListener("click", function (e) {
      var btn = e.target.closest && e.target.closest("[data-video-ctrl]");
      if (!btn) return;
      var wrapper = btn.closest(".autoplay-video-wrapper");
      var video = wrapper && wrapper.querySelector("video");
      if (!video) return;
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
      // The capture-phase play/pause listeners below keep the icon in sync.
    });

    // play / pause / loadedmetadata don't bubble, so listen in the capture
    // phase to catch them from any current OR future video and keep its
    // button icon in sync with the real playback state.
    ["play", "pause", "loadedmetadata"].forEach(function (evt) {
      document.addEventListener(
        evt,
        function (e) {
          var video = e.target;
          if (!video || video.tagName !== "VIDEO") return;
          var wrapper =
            video.closest && video.closest(".autoplay-video-wrapper");
          if (!wrapper) return;
          var btn = wrapper.querySelector("[data-video-ctrl]");
          if (btn) syncVideoBtn(btn, video);
        },
        true
      );
    });
  }

  // Reflect the correct initial icon state for whatever is in the DOM now.
  syncAllVideoBtns();

  // Honour prefers-reduced-motion: pause all autoplay videos on load
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    document
      .querySelectorAll(
        ".autoplay-video-wrapper video[autoplay], .autoplay-video-wrapper video[data-autoplay-on-view]",
      )
      .forEach(function (video) {
        video.pause();
        var btn = video
          .closest(".autoplay-video-wrapper")
          .querySelector("[data-video-ctrl]");
        if (btn) syncVideoBtn(btn, video);
      });
  }
}

/**
 * Lazy autoplay.
 *
 * `autoplay` makes a browser download the whole file straight away — it
 * overrides preload="metadata" — so autoplaying decorative video far below the
 * fold cost ~9MB per PDP load for video most visitors never scrolled to. The
 * markup now ships preload="none" and data-autoplay-on-view instead, and
 * playback starts only once the video is near the viewport.
 *
 * Videos are left paused under prefers-reduced-motion; the existing play/pause
 * button still starts them on demand.
 */
function initLazyAutoplayVideos() {
  var videos = document.querySelectorAll("video[data-autoplay-on-view]");
  if (!videos.length) return;

  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduceMotion) return;

  var start = function (video) {
    if (video.dataset.autoplayStarted) return;
    video.dataset.autoplayStarted = "1";
    video.preload = "auto";
    video.muted = true; // required for programmatic playback
    var played = video.play();
    if (played && typeof played.catch === "function") {
      played.catch(function () {
        /* autoplay refused — the play/pause button still works */
      });
    }
  };

  if (!("IntersectionObserver" in window)) {
    videos.forEach(start);
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        start(entry.target);
        observer.unobserve(entry.target);
      });
    },
    // Begin loading just before it scrolls in, so it is playing on arrival.
    { rootMargin: "200px 0px" },
  );
  videos.forEach(function (v) {
    observer.observe(v);
  });
}

// Sections swapped in after load (PDP template change, see theme.js
// _applyTemplateChange) call these again for their new videos. Both are safe to
// repeat: the click handlers are delegated and bound once, and a video that has
// already started is skipped.
window.initVideoPlayPause = initVideoPlayPause;
window.initLazyAutoplayVideos = initLazyAutoplayVideos;

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", function () {
    initVideoPlayPause();
    initLazyAutoplayVideos();
  });
} else {
  initVideoPlayPause();
  initLazyAutoplayVideos();
}

new ABTest();